import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  Dropdown,
  Modal,
  Nav,
  ProgressBar,
  Spinner,
  Tab,
  Table,
} from "react-bootstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL, Assets_URL } from "../../../Apicongfig";
import { useTranslation } from "react-i18next";
import { useHeaderTitle } from "../../../../context/HeaderTitleContext";
import { toast } from "react-toastify";
import { FaArrowRight, FaLocationDot } from "react-icons/fa6";
import { AiOutlineDelete, AiOutlineEye } from "react-icons/ai";
import { BiDotsVerticalRounded } from "react-icons/bi";
import moment from "moment";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import {
  MDXEditor,
  MDXEditorMethods,
  headingsPlugin,
  listsPlugin,
  markdownShortcutPlugin,
} from "@mdxeditor/editor";
import "@mdxeditor/editor/style.css";

import {
  MdContentCopy,
  MdEdit,
  MdInfo,
  MdOutlineShare,
  MdOutlineSummarize,
  MdRefresh,
} from "react-icons/md";
import { openLinkInNewTab } from "../../../Utils/openLinkInNewTab";
import copy from "copy-to-clipboard";
import Participant from "./Participant";
import ReportStepChart from "./ReportStepChart";
import ReportDecisionCard from "./ReportDecisionCard";
import { Avatar, Tooltip } from "antd";
import { CiEdit, CiShare2 } from "react-icons/ci";
import ReportStepCard from "./ReportStepCard";
import { FaChartGantt } from "react-icons/fa6";
import { FaList, FaPhoneAlt, FaRegFileAudio, FaStar } from "react-icons/fa";
import ConfirmationModal from "../../../Utils/ConfirmationModal";
import { IoArrowBackSharp } from "react-icons/io5";
import { useMeetings } from "../../../../context/MeetingsContext";
import {
  abortMeetingTime,
  groupWordsIntoSentences,
  localizeEstimateTime,
} from "../../../Utils/MeetingFunctions";
import { useFormContext } from "../../../../context/CreateMeetingContext";
import NewMeetingModal from "../CreateNewMeeting/NewMeetingModal";
import { BsPersonWorkspace } from "react-icons/bs";
import { useSteps } from "../../../../context/Step";
import { RiEditBoxLine, RiPresentationFill } from "react-icons/ri";
import CompletedMomentStepFile from "./CompletedMomentStepFile";
import ViewFilePreview from "../ViewFilePreview";
import { CgTranscript } from "react-icons/cg";
import {
  convertDateToUserTimezone,
  convertTo12HourFormat,
  formatDate,
  formatTime,
  handleCopy,
  parseAndFormatDateTime,
  specialMeetingEndTime,
  timezoneSymbols,
  userId,
  userTimeZone,
} from "../GetMeeting/Helpers/functionHelper";
import FeedbackCard from "./FeedbackCard";
import HostCard from "../CurrentMeeting/components/HostCard";
import FileUploadModal from "../CreateNewMeeting/FileUploadModal";
import SubscriberCard from "../CurrentMeeting/components/SubscriberCard";
import { runStepTranscription } from "../../../../Helpers/useStepTranscription";
import { Editor } from "@tinymce/tinymce-react";
import { getMeeting } from "../GetMeeting/Helpers/apiHelper";
import StepFile from "./../CurrentMeeting/components/StepFile";
import MeetingDiscussion from "../CurrentMeeting/components/MeetingDiscussion";

const CompletedInvite = () => {
  const APIKEY = process.env.REACT_APP_TINYMCE_API;

  const location = useLocation();
  const navigate = useNavigate();
  const {
    handleShow,
    open,
    setMeeting,
    setIsDuplicate,
    setCheckId,
    handleCloseModal,
    setChangePrivacy,
    setChangeContext,
    setChangeOptions,
    call,
    changePrivacy,
    changeContext,
    changeOptions,
    setFormState,
  } = useFormContext();
  const getTimezoneSymbol = (timezone) => timezoneSymbols[timezone] || timezone;

  let fromMeeting = true;
  if (location?.state?.from === "meeting") {
    fromMeeting = true;
  }
  let isDisabled = false;
  if (location?.state?.disabled === "yes") {
    isDisabled = true;
  }
  const { id } = useParams();
  const [t] = useTranslation("global");
  const { setHeaderTitle } = useHeaderTitle();
  const { setStatus, setClosedOffset } = useMeetings();
  const { updateSteps } = useSteps();
  const [meetingSummary, setMeetingSummary] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [originalSummary, setOriginalSummary] = useState(meetingSummary || "");

  // Update originalSummary when meetingSummary changes
  useEffect(() => {
    setOriginalSummary(meetingSummary || "");
  }, [meetingSummary]);




  const handleCancelEdit = () => {
    setMeetingSummary(originalSummary);
    setIsEditing(false);
  };

  // Use meetingSummary directly as markdown content, with fallback to empty string
  const markdownContent = meetingSummary || "";

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFileUploaded, setIsFileUploaded] = useState(false);

  const [meeting, setMeeting1] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [startTime1, setStartTime1] = useState(null);
  const [time, setTime] = useState(null);

  const [estimateTime, setEstimateTime] = useState(null);
  const [estimateDate, setEstimateDate] = useState(null);
  const [reportData, setReportData] = useState(null);
  const [meetingTranscript, setMeetingTranscript] = useState(null);
  const [meetingTranscriptWithTimeStamps, setMeetingTranscriptWithTimeStamps] =
    useState(null);
  console.log("meetingSummary", meetingSummary);
  const [meetingAudio, setMeetingAudio] = useState(null);
  const [meetAudio, setMeetAudio] = useState(null);

  const [isTimeStampChecked, setIsTimeStampChecked] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const handleEditToggle = () => {
    setEditMode(!editMode);
  };
  const handleCheckboxChange = () => {
    setIsTimeStampChecked(!isTimeStampChecked);
  };

  
  const handleSave1 = () => {
    handleAutoNoteSave({
      ...meeting,
      meeting_notes_summary: meetingSummary || "",
    });
    // setOriginalSummary(meetingSummary || "");
    setIsEditing(false);
  };

  

    // Utility function for debouncing
const debounce = (func, delay) => {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, args), delay);
  };
};

// Add this in your component
const debouncedAutoSave = useMemo(
  () =>
    debounce(async (newSummary) => {
      try {
        setAutoNoteSaving(true);
        const payload = {
          ...meeting,
          meeting_notes_summary: newSummary,
          _method: "put",
        };
        
        const response = await axios.post(
          `${API_BASE_URL}/meetings/${id}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );
        
        if (response?.status) {
          toast.success(t("Changes saved automatically"), { autoClose: 2000 });
        }
      } catch (error) {
        console.error("Auto-save failed:", error);
        toast.error(t("Auto-save failed"));
      } finally {
        setAutoNoteSaving(false);
      }
    }, 2000), // 2-second delay
  [meeting, id]
);
  const [showFileModal, setShowFileModal] = useState(false);
  const handleCloseFileModal = () => {
    setShowFileModal(false);
  };
  const handleFileChange = (event) => {
    event.target.value = "";
  };

  const [meetingMessages, setMeetingMessages] = useState([]);
  useEffect(() => {
    const getMeetingMessages = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/meeting/${id}/messages`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );
        if (response?.status === 200) {
          const data = response?.data?.data;
          const sortedMessages = [...(data || [])].sort(
            (a, b) => new Date(a.created_at) - new Date(b.created_at)
          );
          setMeetingMessages(sortedMessages);
        }
      } catch (error) {
        console.log("error", error);
      }
    };
    getMeetingMessages();
  }, [id]);
  const handleSave = async () => {
    // Extract the updated content from the editable div
    const updatedContent =
      document.getElementById("editable-content").innerHTML;
    // Update local state immediately for a better user experience
    setIsSaving(true);

    const payload = {
      ...meeting,
      meeting_notes: updatedContent,
      _method: "put",
    };
    try {
      // // Call the API to save the updated content
      // await axios.post(saveApiUrl, { report: updatedContent });
      const response = await axios.post(
        `${API_BASE_URL}/meetings/${id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (response?.status) {
        setEditMode(false);
        setReportData(response?.data?.data?.meeting_notes);

        // Exit edit mode after a successful save
        toast.success("Report is Edited successfully");
      }
    } catch (error) {
      console.error("Failed to save the report:", error);
      alert("Failed to save the report. Please try again.");
    } finally {
      setIsSaving(false);
    }
  };

  const [autoNoteSaving, setAutoNoteSaving] = useState(false);

  const handleAutoNoteSave = async () => {
    // Extract the updated content from the editable div

    // Update local state immediately for a better user experience
    setAutoNoteSaving(true);

    const payload = {
      ...meeting,
      meeting_notes_summary: meetingSummary,
      _method: "put",
    };
    try {
      // // Call the API to save the updated content
      // await axios.post(saveApiUrl, { report: updatedContent });
      const response = await axios.post(
        `${API_BASE_URL}/meetings/${id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (response?.status) {
        setEditMode(false);
        // setMeetingSummary(response?.data?.data?.meeting_notes_summary);
        await getReportMeeting();

        // Exit edit mode after a successful save
        toast.success(t("Report is Edited successfully"));
      }
    } catch (error) {
      console.error("Failed to save the report:", error);
      // alert("Failed to save the report. Please try again.");
      toast.error(t("Failed to save the report: API error"));
    } finally {
      setAutoNoteSaving(false);
    }
  };

  const [reportProgress, setReportProgress] = useState(0);
  const [showReportProgressBar, setShowReportProgressBar] = useState(false);

  const [isCalling, setIsCalling] = useState(false);
  const getReportMeeting = async () => {
    const currentTime = new Date();
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const options = { timeZone: userTimeZone };
    const timeInUserZone = new Date(
      currentTime.toLocaleString("en-US", options)
    );

    const formattedTime = formatTime(timeInUserZone);
    const formattedDate = formatDate(timeInUserZone);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/get-meeting/${id}?current_time=${formattedTime}&current_date=${formattedDate}&timezone=${userTimeZone}`
      );
      if (response.status) {
        const data = response?.data?.data;
        const cleanUrl = data?.voice_notes;
        setMeetAudio(cleanUrl);
        setStatus(response?.data?.data?.status);
        setHeaderTitle({ titleText: " " });
        const steps = response.data?.data?.steps;
        const time = response?.data?.data?.start_time;
        setMeeting1(response.data?.data);
        setTime(response?.data?.data?.start_time);
        setMeetingSummary(response.data?.data?.meeting_notes_summary);
        // setMeetingTranscript(response.data?.data?.meeting_notes_transcript);
        setMeetingTranscript(data.meeting_notes_transcript.transcript);
        setMeetingTranscriptWithTimeStamps(data.meeting_notes_transcript);
        if (response?.data?.data?.meeting_notes) {
          setReportData(response?.data?.data?.meeting_notes);
          setReportProgress(false);
          setIsCalling(true);
        }
        const { formattedDate: estimateDate, formattedTime: estimateTime } =
          parseAndFormatDateTime(
            data?.estimate_time,
            data?.type,
            data?.timezone
          );
        setEstimateTime(estimateTime);
        setEstimateDate(estimateDate);
      }
    } catch (error) {
      console.log("error while fetching meeting data", error);
    } finally {
    }
  };

  const getRefreshMeeting = async () => {
    const currentTime = new Date();
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const options = { timeZone: userTimeZone };
    const timeInUserZone = new Date(
      currentTime.toLocaleString("en-US", options)
    );

    const formattedTime = formatTime(timeInUserZone);
    const formattedDate = formatDate(timeInUserZone);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/get-meeting/${id}?current_time=${formattedTime}&current_date=${formattedDate}&timezone=${userTimeZone}`
      );
      if (response.status) {
        const data = response.data?.data;

        setStatus(data?.status);
        setHeaderTitle({ titleText: " " });

        const steps = data?.steps;
        const time = data?.start_time;
        setMeeting1(data);
        setTime(time);
        setMeetingSummary(response.data?.data?.meeting_notes_summary);
        setMeetingTranscript(
          response.data?.data?.meeting_notes_transcript.transcript
        );
        setMeetingTranscriptWithTimeStamps(
          response.data?.data?.meeting_notes_transcript
        );
        if (data?.meeting_notes) {
          setReportData(data?.meeting_notes);
          setReportProgress(false);
          setIsCalling(true);
        }

        const { formattedDate: estimateDate, formattedTime: estimateTime } =
          parseAndFormatDateTime(
            data?.estimate_time,
            data?.type,
            data?.timezone
          );
        setEstimateTime(estimateTime);
        setEstimateDate(estimateDate);
      }
    } catch (error) {
      console.log("error while fetching meeting data", error);
    }
  };

  const [callUpmeet, setCallUpmeet] = useState(false);

  useEffect(() => {
    const getMeeting = async () => {
      setIsLoading(true);
      try {
        const currentTime = new Date();
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        const options = { timeZone: userTimeZone };
        const timeInUserZone = new Date(
          currentTime.toLocaleString("en-US", options)
        );

        const formattedTime = formatTime(timeInUserZone);
        const formattedDate = formatDate(timeInUserZone);
        const response = await axios.get(
          `${API_BASE_URL}/get-meeting/${id}?current_time=${formattedTime}&current_date=${formattedDate}&timezone=${userTimeZone}`
        );
        if (response.status) {
          const data = response.data?.data;

          setStatus(data?.status);
          setHeaderTitle({ titleText: " " });

          const steps = data?.steps;
          const time = data?.start_time;
          setMeeting1(data);
          setTime(time);
          // Check if meeting_notes_summary exists
          if (data.meeting_notes_summary) {
            setMeetingSummary(response.data?.data?.meeting_notes_summary);
            setCallUpmeet(false); // No need to poll
          } else {
            setCallUpmeet(true); // Need to poll for summary
          }

          setMeetingTranscript(response.data?.data?.meeting_notes_transcript);
          if (data?.meeting_notes) {
            setReportData(data?.meeting_notes);
            setReportProgress(false);
            setIsCalling(true);
          }

          const { formattedDate: estimateDate, formattedTime: estimateTime } =
            parseAndFormatDateTime(
              data?.estimate_time,
              data?.type,
              data?.timezone
            );
          setEstimateTime(estimateTime);
          setEstimateDate(estimateDate);
        }
      } catch (error) {
        console.log("error while fetching meeting data", error);
      } finally {
        setIsLoading(false);
      }
    };
    setClosedOffset(0);

    getMeeting();
  }, [id, changePrivacy, changeOptions, changeContext]);
  useEffect(() => {
    getReportMeeting();
  }, [call]);
  const [loading, setLoading] = useState(false);
  const [transcriptLoading, setTranscriptLoading] = useState(false);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [viewNote, setViewNote] = useState("note");

  // useEffect(() => {
  //   let pollingInterval;

  //   const getMeeting = async () => {
  //     // Stop polling if prise_de_notes is not Automatic
  //     if (meeting?.prise_de_notes !== "Automatic") {
  //       return;
  //     }

  //     setLoading(true);
  //     const currentTime = new Date();
  //     const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  //     const options = { timeZone: userTimeZone };
  //     const timeInUserZone = new Date(
  //       currentTime.toLocaleString("en-US", options)
  //     );

  //     const formattedTime = formatTime(timeInUserZone);
  //     const formattedDate = formatDate(timeInUserZone);
  //     try {
  //       const response = await axios.get(
  //         `${API_BASE_URL}/get-meeting/${id}?current_time=${formattedTime}&current_date=${formattedDate}`
  //       );
  //       if (response.status) {
  //         const data = response.data?.data;

  //         // Check if voice_notes is available
  //         if (data?.voice_notes) {
  //           const cleanUrl = data?.voice_notes;
  //           setMeetingAudio(cleanUrl);
  //           setMeetingSummary(data?.meeting_notes_summary);
  //           setMeetingTranscript(data?.meeting_notes_transcript?.transcript);
  //           setMeetingTranscriptWithTimeStamps(data?.meeting_notes_transcript);
  //           clearInterval(pollingInterval); // Stop polling if voice_notes is available
  //           setLoading(false);
  //           setViewNote("note");
  //         }
  //       }
  //     } catch (error) {
  //       console.log("error while fetching meeting data", error);
  //     }
  //   };

  //   // Start polling only if prise_de_notes is Automatic
  //   if (meeting?.prise_de_notes === "Automatic") {
  //     pollingInterval = setInterval(getMeeting, 5000); // Poll every 5 seconds

  //     // Initial call
  //     if (!meetingAudio) {
  //       getMeeting();
  //     }
  //   }

  //   // Cleanup interval on component unmount
  //   return () => clearInterval(pollingInterval);
  // }, [id, meeting?.prise_de_notes]); // Added meeting?.prise_de_notes as a dependency

  useEffect(() => {
    let pollingInterval;

    const getMeeting = async () => {
      // Stop polling if prise_de_notes is not Automatic
      if (meeting?.prise_de_notes !== "Automatic" || meetAudio === null) {
        return;
      }

      setLoading(true);
      const currentTime = new Date();
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const options = { timeZone: userTimeZone };
      const timeInUserZone = new Date(
        currentTime.toLocaleString("en-US", options)
      );

      const formattedTime = formatTime(timeInUserZone);
      const formattedDate = formatDate(timeInUserZone);
      try {
        const response = await axios.get(
          `${API_BASE_URL}/get-meeting/${id}?current_time=${formattedTime}&current_date=${formattedDate}&timezone=${userTimeZone}`
        );
        if (response.status) {
          const data = response.data?.data;

          // Check if voice_notes is available
          if (data?.voice_notes) {
            const cleanUrl = data?.voice_notes;
            setMeetingAudio(cleanUrl);
            setMeetingSummary(data?.meeting_notes_summary);
            setMeetAudio(data?.voice_notes);
            setMeetingTranscript(data?.meeting_notes_transcript?.transcript);
            setMeetingTranscriptWithTimeStamps(data?.meeting_notes_transcript);
            clearInterval(pollingInterval); // Stop polling if voice_notes is available
            setLoading(false);
            setViewNote("note");
          }
        }
      } catch (error) {
        console.log("error while fetching meeting data", error);
      }
    };

    // Start polling only if prise_de_notes is Automatic
    if (meeting?.prise_de_notes === "Automatic" && meetAudio === null) {
      pollingInterval = setInterval(getMeeting, 5000); // Poll every 5 seconds

      // Initial call
      if (!meetingAudio) {
        getMeeting();
      }
    }

    // Cleanup interval on component unmount
    return () => clearInterval(pollingInterval);
  }, [id, meeting?.prise_de_notes, meetAudio]); // Added meeting?.prise_de_notes as a dependency
  useEffect(() => {
    let pollingInterval;

    const getMeeting = async () => {
      // Stop polling if prise_de_notes is not Automatic
      if (meeting?.prise_de_notes !== "Automatic" || meetAudio === null) {
        return;
      }

      setTranscriptLoading(true);
      setSummaryLoading(true);

      try {
        const currentTime = new Date();
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        const options = { timeZone: userTimeZone };
        const timeInUserZone = new Date(
          currentTime.toLocaleString("en-US", options)
        );

        const formattedTime = formatTime(timeInUserZone);
        const formattedDate = formatDate(timeInUserZone);
        const response = await axios.get(
          `${API_BASE_URL}/get-meeting/${id}?current_time=${formattedTime}&current_date=${formattedDate}&timezone=${userTimeZone}`
        );
        if (response.status) {
          const data = response.data?.data;

          const hasTranscript = data?.meeting_notes_transcript?.transcript;
          const hasSummary = data?.meeting_notes_summary;

          if (hasTranscript) {
            setMeetingTranscript(data.meeting_notes_transcript.transcript);
            setMeetingTranscriptWithTimeStamps(data.meeting_notes_transcript);
          }

          if (hasSummary) {
            setMeetingSummary(data.meeting_notes_summary);
          }

          // Jab dono aa jayein tab loading hatao aur polling band karo
          if (hasTranscript && hasSummary) {
            clearInterval(pollingInterval);
            setTranscriptLoading(false);
            setSummaryLoading(false);
            setViewNote("note");
          }
        }
      } catch (error) {
        console.log("error while fetching meeting data", error);
      }
    };

    if (meeting?.prise_de_notes === "Automatic" && meetAudio === null) {
      pollingInterval = setInterval(getMeeting, 5000); // Poll every 5 seconds
      // Initial call
      if (!meetingTranscript || !meetingSummary) {
        getMeeting();
      }
    }

    return () => clearInterval(pollingInterval);
  }, [id, meeting?.prise_de_notes, meetAudio]);

  // This is the GET API function you want to call after upload succeeds
  const fetchNotesData = async () => {
    try {
      const token =
        sessionStorage.getItem("token") || localStorage.getItem("token");
      const response = await axios.get(
        `${API_BASE_URL}/get-upmeet-report/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data; // Return full response (check for response.data.data later)
    } catch (error) {
      console.error("Error fetching notes:", error);
      throw error;
    }
  };
  const shouldGenerateSummary = () => {
    return (
      meeting?.prise_de_notes === "Automatic"
    );
  };
  const handleAudioUploadSuccess = async () => {
    if (shouldGenerateSummary()) {
    // Your condition check
    setSummaryLoading(true);

    // Start polling
    const poll = async () => {
      try {
        const response = await fetchNotesData();

        if (response?.data?.upmeet_summary) {
          setTimeout(() => {
            setMeetingSummary(response.data?.upmeet_summary?.text);
            setMeetingTranscript(
              response.data?.upmeet_full_transcription?.text
            );
            setSummaryLoading(false);
            getReportMeeting();
          }, 500); // Let progress complete
          return true;
        }
        return false;
      } catch (error) {
        console.error("Polling error:", error);
        return false;
      }
    };

    // Recursive polling with exponential backoff
    const startPolling = async (attempt = 0) => {
      const success = await poll();
      if (!success && attempt < 60) {
        // Max ~5 minutes
        setTimeout(
          () => startPolling(attempt + 1),
          Math.min(1000 * Math.pow(1.5, attempt), 10000)
        );
      } else if (!success) {
        setSummaryLoading(false);
        // toast.error("Summary generation is taking longer than expected. Please check back later.");
      }
    };

    await startPolling();
    }
  };

  useEffect(() => {
    handleAudioUploadSuccess();
  }, [callUpmeet, id, meetAudio]);

  // useEffect(() => {
  //   if (meetingAudio && !meetingTranscript) {
  //     const fetchTranscript = async () => {
  //       setTranscriptLoading(true);
  //       try {
  //         const response = await axios.get(
  //           `${API_BASE_URL}/transcripte-meeting-notes/${id}`
  //         );
  //         if (response.status) {
  //           setTranscriptLoading(false);
  //           setMeetingTranscript(
  //             response.data?.data?.meeting_notes_transcript?.transcript
  //           );
  //           setMeetingTranscriptWithTimeStamps(
  //             response.data?.data?.meeting_notes_transcript
  //           );

  //           setViewNote("note");
  //         }
  //       } catch (error) {
  //         console.log("error while fetching meeting transcript", error);
  //         setTranscriptLoading(false);
  //         toast.error("transription Failed, Please Refresh the Page");
  //       }
  //     };
  //     if (!meetingTranscript) {
  //       fetchTranscript();
  //     }
  //   }
  // }, [meetingAudio,meetingTranscript]);

  // useEffect(() => {
  //   if (meetingTranscript && !meetingSummary) {
  //     const fetchSummary = async () => {
  //       setSummaryLoading(true);
  //       try {
  //         const response = await axios.get(
  //           `${API_BASE_URL}/summarize-meeting-notes/${id}`
  //         );
  //         if (response.status) {
  //           setSummaryLoading(false);

  //           setMeetingSummary(response.data?.data?.meeting_notes_summary);
  //    await runStepTranscription(response.data?.data); // <-- call transcription after success
  //         }
  //       } catch (error) {
  //         console.log("error while fetching meeting summary", error);
  //         toast.error("Summarization Failed, Please Refresh the Page");
  //         setSummaryLoading(false);
  //       }finally{

  //       }
  //     };
  //     if (!meetingSummary) {
  //       fetchSummary();
  //     }
  //   }
  // }, [meetingTranscript,meetingSummary]);

  const getRefreshedMeeting = async () => {
    try {
      const currentTime = new Date();
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const options = { timeZone: userTimeZone };
      const timeInUserZone = new Date(
        currentTime.toLocaleString("en-US", options)
      );

      const formattedTime = formatTime(timeInUserZone);
      const formattedDate = formatDate(timeInUserZone);
      const response = await axios.get(
        `${API_BASE_URL}/get-meeting/${id}?current_time=${formattedTime}&current_date=${formattedDate}&timezone=${userTimeZone}`
      );
      if (response.status) {
        const data = response.data?.data;
        setStatus(data.status);
        setHeaderTitle({ titleText: " " });
        const steps = data?.steps;
        const time = data?.start_time;
        setMeeting1(data);
        setTime(data?.start_time);
        updateSteps(steps);

        const { formattedDate: estimateDate, formattedTime: estimateTime } =
          parseAndFormatDateTime(
            data?.estimate_time,
            data?.type,
            data?.timezone
          );
        setEstimateTime(estimateTime);
        setEstimateDate(estimateDate);
      }
    } catch (error) {
      console.log("error while fetching meeting data", error);
    } finally {
    }
  };

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [itemIdToDelete, setItemIdToDelete] = useState(null);
  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}/meetings/${id}`, {
        headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
      });

      if (response.status === 200) {
        toast.success("Réunion supprimée avec succès");
        // getMeetings();
        navigate("/meeting");
      } else {
        throw new Error("Échec de la suppression de la réunion");
      }
    } catch (error) {
      toast.error(t(error.message));
    } finally {
      setFormState({});
    }
  };
  const handleDeleteClick = (e, id) => {
    e.stopPropagation();
    setItemIdToDelete(id);
    setShowConfirmationModal(true);
  };

  const handleChangePrivacy = (item) => {
    setCheckId(item?.id);
    setFormState(item);
    setChangePrivacy(true);
    setMeeting(item);
    handleShow();
  };

  const handleChangeContext = (item) => {
    setCheckId(item?.id);
    setFormState(item);
    setChangeOptions(false);
    setChangeContext(true);
    setMeeting(item);
    handleShow();
  };
  const handleChangeOptions = (item) => {
    setCheckId(item?.id);
    setFormState(item);
    setChangeContext(false);
    setChangeOptions(true);
    setMeeting(item);
    handleShow();
  };
  const confirmDelete = (e) => {
    e.stopPropagation();
    setShowConfirmationModal(false);
    handleDelete(itemIdToDelete);
  };

  const sendReport = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/send-report-link`,
        { meeting_id: parseInt(id) },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (response?.status) {
        toast.success(t("Report sent successfully"));
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const viewInvitePresentation = (item) => {
    navigate(`/destination/${item?.unique_id}/${item.id}`, {
      state: { item, from: "inviteMeeting" },
    });
  };
  const loggedInUserId = sessionStorage.getItem("user_id");

  const [view, setView] = useState("grid");

  const handleToggle = () => {
    setView(view === "grid" ? "list" : "grid");
  };

  // const startDate1 = new Date(meeting?.date);
  // // Get individual components of the date
  // const day = String(startDate1.getDate()).padStart(2, "0");
  // const startMonth = String(startDate1.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  // const year = startDate1.getFullYear();

  // // Format the date in dd:mm:yyyy
  // // const formattedStartDate = `${day}/${startMonth}/${year}`;
  const formattedStartDate = convertDateToUserTimezone(
    meeting?.date,
    meeting?.starts_at || meeting?.start_time,
    meeting?.timezone
  );

  const filteredActions = meeting?.plan_d_actions?.reduce((acc, item) => {
    // Find if an entry with the same action, order, and action_days already exists
    const existing = acc.find(
      (obj) =>
        obj.action === item.action &&
        obj.order === item.order &&
        obj.action_days === item.action_days
    );

    // If it exists, we skip adding the current item to the accumulator
    if (!existing) {
      acc.push(item);
    }

    return acc;
  }, []);

  const guideEmails = new Set(meeting?.guides?.map((guide) => guide.email));
  const [showProfile, setShowProfile] = useState(false);

  const handleShow1 = () => {
    setShowProfile(true);
  };
  const hideShow = () => {
    setShowProfile(false);
  };

  //Host
  const [showHostProfile, setShowHostProfile] = useState(false);
  const [showOrgProfile, setShowOrgProfile] = useState(false);

  const handleHostShow = () => {
    setShowHostProfile(true);
  };
  const hideHostShow = () => {
    setShowHostProfile(false);
  };

  const handleOrgShow = () => {
    setShowOrgProfile(true);
  };
  const hideOrgShow = () => {
    setShowOrgProfile(false);
  };

  const [modalContent, setModalContent] = useState(null);

  const openModal = (file) => {
    setModalContent(file);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalContent(null);
  };

  const handleViewToggle = async (view) => {
    if (view === "prompt") {
      await handleToggleInfo();
    }
    setViewNote(view);
  };
  const sessionUser = JSON.parse(sessionStorage.getItem("user"));
  const [hoveredWord, setHoveredWord] = useState(null);

  // const sentences = meetingTranscriptWithTimeStamps?.timestamps;
  const sentences = groupWordsIntoSentences(
    meetingTranscriptWithTimeStamps?.timestamps
  );

  // Memoize sentences to prevent unnecessary re-renders
  const memoizedSentences = useMemo(() => sentences, [sentences]);

  const [showInfo, setShowInfo] = useState(false); // Toggle state
  const [infoContent, setInfoContent] = useState(""); // Initially empty
  const [infoLoading, setInfoLoading] = useState(false);
  const handleToggleInfo = async () => {
    setShowInfo((prev) => !prev); // Toggle info display

    if (!showInfo) {
      // Fetch data only when opening
      setInfoLoading(true);

      try {
        const response = await axios.get(
          `${API_BASE_URL}/meeting-prompts/${meeting?.prompts[0]?.id}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );

        if (response?.status === 200) {
          setInfoContent(response.data?.data?.prompt || ""); // Set fetched content
        }
      } catch (error) {
        console.error("Error fetching prompt:", error);
      } finally {
        setInfoLoading(false);
      }
    }
  };

  const handleUpdatePrompt = async (item) => {
    const updatedPrompt = document.getElementById(
      "info-editable-content"
    ).innerHTML;
    setIsSaving(true);
    const payload = {
      ...item?.prompts[0],
      prompt: updatedPrompt,
      _method: "put",
    };
    try {
      const response = await axios.put(
        `${API_BASE_URL}/meeting-prompts/${item?.prompts[0]?.id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (response?.status) {
        toast.success(t("Prompt updated successfully"));
        handleSecondApiCall();
      }
    } catch (error) {
      console.error("Failed to update the prompt:", error);
      toast.error(t("Failed to update the prompt: API error"));
    } finally {
      setIsSaving(false);
    }
  };

  const handleSecondApiCall = async () => {
    setSummaryLoading(true); // Show progress bar
    setViewNote("note");

    // Start a progress simulation interval
    // const interval = setInterval(simulateProgress, 100); // Increment every 100ms
    try {
      const response = await axios.get(
        `${API_BASE_URL}/summarize-meeting-notes/${meeting?.id}`
      );

      // Clear interval when the request completes
      // clearInterval(interval);
      if (response.status) {
        const newNotes = response?.data?.data?.meeting_notes_summary;
        setMeeting((prevMeeting) => ({
          ...prevMeeting,
          meeting_notes_summary: newNotes,
        }));
        setMeetingSummary(newNotes);
      } else {
        console.log("Second API call failed:", response.data.message);
      }
    } catch (error) {
      console.error("Error in second API call:", error);
    } finally {
      setSummaryLoading(false); // Show progress bar
    }
  };

  // Calculate the average rating
  const validFeedbacks =
    meeting?.meeting_feedbacks?.filter((feedback) => feedback.rating > 0) || [];

  const averageRating =
    validFeedbacks.length > 0
      ? validFeedbacks.reduce((sum, feedback) => sum + feedback.rating, 0) /
        validFeedbacks.length
      : 0;

  const editorRef = useRef(null);
  const handleEditorChange = (content) => {
    // setContent(content);
    setEditValue(content);
  };
  const uploadToCloudinary = async (blobInfo) => {
    return new Promise(async (resolve, reject) => {
      try {
        const formData = new FormData();
        formData.append("file", blobInfo.blob(), blobInfo.filename());
        formData.append("upload_preset", "chat-application"); // Replace with your upload preset
        formData.append("cloud_name", "drrk2kqvy"); // Replace with your cloud name

        const response = await fetch(
          `https://api.cloudinary.com/v1_1/drrk2kqvy/image/upload`,
          {
            method: "POST",
            body: formData,
          }
        );

        if (!response.ok) {
          throw new Error("Upload failed");
        }

        const data = await response.json();
        resolve(data.secure_url); // Return the secure URL from Cloudinary
      } catch (error) {
        console.error("Upload error:", error);
        reject("Image upload failed: " + error.message);
      }
    });
  };

  // const [content, setContent] = useState("");
  const [editingField, setEditingField] = useState(null);
  const [editValue, setEditValue] = useState("");

  const handleEditTitle = (meeting) => {
    setEditingField("title");
    setEditValue(meeting.title);
  };
  const handleEditDescription = (meeting) => {
    setEditingField("description");
    setEditValue(meeting.description);
    // setContent(meeting.description);
  };

  const handleSaveEdit = async () => {
    try {
      const token = sessionStorage.getItem("token");

      // Construct the payload with all meeting data, only updating the edited field
      const updatedMeeting = {
        ...meeting, // keep all other fields
        [editingField]: editValue, // only update the edited field
        _method: "put",
      };

      const response = await axios.post(
        `${API_BASE_URL}/meetings/${meeting.id}`,
        updatedMeeting,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 200) {
        setEditingField(null);
        await getRefreshedMeeting();
        toast.success(t("Updated successfully"));
      }
    } catch (error) {
      toast.error("Failed to update");
    }
  };

  const [uploadStage, setUploadStage] = useState("");
  const [progress, setProgress] = useState(0);
  const [showProgressBar, setShowProgressBar] = useState(false);

const uploadAudioToCloudinary = async (newBlob) => {
  setShowProgressBar(true);
  setProgress(0);
  setUploadStage(t("note_translation.Uploading audio"));

  // Start progress animation
  const interval = setInterval(() => {
    setProgress((prev) => (prev >= 90 ? 90 : prev + 10));
  }, 200);

  try {
    // Create separate FormData objects for each endpoint
    const upmeetFormData = new FormData();
    const audioRouteFormData = new FormData();

    // Common meeting ID
    upmeetFormData.append("meeting_id", id);
    audioRouteFormData.append("meeting_id", id);

    // Different field names for the audio file
    const audioFile = new File([newBlob], "audio.wav", { type: "audio/wav" });
    upmeetFormData.append("file", audioFile);
    audioRouteFormData.append("voice_notes", audioFile);

    const token = sessionStorage.getItem("token") || localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    // Retry configuration
    const maxRetries = 3;
    const retryDelay = 1000; // 1 second

    // Function to make request with retries
    const makeRequestWithRetry = async (url, data, attempts = 0) => {
      try {
        const response = await axios.post(url, data, { headers });
        return response;
      } catch (error) {
        if (attempts < maxRetries) {
          await new Promise(resolve => setTimeout(resolve, retryDelay * (attempts + 1)));
          return makeRequestWithRetry(url, data, attempts + 1);
        }
        throw error;
      }
    };

    // Start both uploads in parallel
    const [upmeetResponse, audioRouteResponse] = await Promise.all([
      makeRequestWithRetry(`${API_BASE_URL}/upmeet-upload`, upmeetFormData),
      makeRequestWithRetry(`${API_BASE_URL}/audio-route`, audioRouteFormData)
    ]);

    // Check both responses (accepting 200 or 201 status codes)
    const upmeetSuccess = upmeetResponse?.status === 200 || upmeetResponse?.status === 201;
    const audioRouteSuccess = audioRouteResponse?.status === 200 || audioRouteResponse?.status === 201;

    if (upmeetSuccess && audioRouteSuccess) {
      setProgress(95);
      setUploadStage(t("note_translation.Processing Notes"));
      
      // Start polling for the report
      await pollForReport();
    } else {
      throw new Error("One or more uploads failed");
    }
  } catch (error) {
    console.error("❌ Error uploading audio:", error);
    toast.error("Audio uploading failed!");
    toast.error(error?.response?.data?.message || error.message);
    throw new Error("Failed to upload audio");
  } finally {
    clearInterval(interval);
    setProgress(100);
    setUploadStage("");
    setTimeout(() => setShowProgressBar(false), 500);
  }
};

const pollForReport = async () => {
  const maxAttempts = 5000; // 30 attempts
  const delay = 60000; // 1 min between attempts
  let attempts = 0;

  const fetchReport = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/get-upmeet-report/${id}`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token") || localStorage.getItem("token")}`
        }
      });
      
      const data = response.data?.data;
      
      if (data) {
        // Both transcript and summary are available
        setMeetingTranscript(data.transcript);
        setMeetingSummary(data.upmeet_summary?.text);
        setViewNote("note");
          setShowProgressBar(false);
        return true;
      }
      return false;
    } catch (error) {
      console.error("Error fetching report:", error);
      return false;
    }
  };

  while (attempts < maxAttempts) {
    attempts++;
    const success = await fetchReport();
    if (success) {
      return;
    }
    await new Promise(resolve => setTimeout(resolve, delay));
  }

  throw new Error("Timeout waiting for report");
};
  const hasTranscribedRef = useRef(false);

  const [transcriptionProgress, setTranscriptionProgress] = useState(0);
  const [isTranscribing, setIsTranscribing] = useState(false);

  const handleTranscriptionAndNext = async () => {
    setShowProgressBar(true);
    setUploadStage(t("note_translation.Processing Step Note"));
    setProgress(0);

    const simulateProgress = () => {
      setProgress((prev) => {
        if (prev >= 75) return prev;
        return prev + 1;
      });
    };

    const interval = setInterval(simulateProgress, 100);

    try {
      const currentTime = new Date();
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const options = { timeZone: userTimeZone };
      const timeInUserZone = new Date(
        currentTime.toLocaleString("en-US", options)
      );

      const formattedTime = formatTime(timeInUserZone);
      const formattedDate = formatDate(timeInUserZone);

      // STEP 1: Fetch current meeting before transcription
      const initialResponse = await axios.get(
        `${API_BASE_URL}/get-meeting/${id}?current_time=${formattedTime}&current_date=${formattedDate}&timezone=${userTimeZone}`
      );

      const meeting = initialResponse?.data?.data;

      // STEP 2: Run transcription
      await runStepTranscription(meeting);

      // STEP 3: Fetch latest version after transcription
      const refreshedResponse = await axios.get(
        `${API_BASE_URL}/get-meeting/${id}?current_time=${formattedTime}&current_date=${formattedDate}&timezone=${userTimeZone}`
      );

      clearInterval(interval);

      if (refreshedResponse?.status === 200) {
        const updatedMeeting = refreshedResponse.data.data;
        setMeeting(updatedMeeting);
        setProgress(100);
        hasTranscribedRef.current = true;

        setTimeout(() => {
          setShowProgressBar(false);
          setUploadStage("");
        }, 500);
      }
    } catch (err) {
      console.error("❌ Error during transcription flow:", err);
      clearInterval(interval);
      setShowProgressBar(false);
      setUploadStage("");
    } finally {
      getMeeting();
    }
  };

  // const handleRefresh = async () => {
  //   setShowProgressBar(true);
  //   setProgress(0);
  //   setUploadStage(t("note_translation.Fetching Transcription"));

  //   const interval = setInterval(() => {
  //     setProgress((prev) => {
  //       if (prev >= 90) {
  //         clearInterval(interval);
  //         return 90;
  //       }
  //       return prev + 10;
  //     });
  //   }, 200);

  //   // await fetchTranscript();
  // };

  const [activeTab, setActiveTab] = useState("casting");

  // Initialize active tab from local storage
  useEffect(() => {
    const savedTab = localStorage.getItem("meetingActiveTab") || "casting";
    if (
      savedTab &&
      [
        "casting",
        "steps",
        // "stepNotes",
        "meetingNotes",
        "files",
        "feedbacks",
      ].includes(savedTab)
    ) {
      setActiveTab(savedTab);
    }
  }, []);


  // useEffect(()=>{
  //   setActiveTab("casting")
  // },[])

  // Save to local storage when tab changes
  const handleTabSelect = (tab) => {
    setActiveTab(tab);
    localStorage.setItem("meetingActiveTab", tab);
  };

  const [editingStepId, setEditingStepId] = useState(null);
  const [currentNote, setCurrentNote] = useState("");
  const [isSavingNote, setIsSavingNote] = useState(false);

  const handleSaveStepNote = async (step) => {
    setIsSavingNote(true);
    try {
      const response = await axios.put(
        `${API_BASE_URL}/steps/${step?.id}`,
        {
          ...step,
          note: currentNote,
          _method: "put",
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (response.data.success) {
        // setSteps(updatedSteps);
        await getRefreshedMeeting(); // Refresh the meeting data
        setEditingStepId(null);
        toast.success("step Note updated successfully");
      }
    } catch (error) {
      toast.error("Failed to save note");
      console.error(error);
    } finally {
      setIsSavingNote(false);
    }
  };
  return (
    <>
      {isLoading ? (
        <Spinner
          animation="border"
          role="status"
          className="center-spinner"
        ></Spinner>
      ) : (
        <div
          className="complete-invite w-100"
          style={{
            position: fromMeeting ? "static" : "relative",
            backgroundColor: fromMeeting ? "white" : "",
            padding: "10px 15px",
          }}
        >
          {/* Progress Bar Section */}
          {showProgressBar && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.7)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  backgroundColor: "white",
                  padding: "30px",
                  borderRadius: "10px",
                  width: "50%",
                  maxWidth: "500px",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    marginBottom: "20px",
                    fontWeight: "bold",
                    fontSize: "18px",
                  }}
                >
                  {uploadStage}
                </div>
                <ProgressBar
                  now={progress}
                  label={`${progress}%`}
                  style={{ height: "20px" }}
                />
                <div style={{ marginTop: "10px", color: "#666" }}>
                  {t(
                    "note_translation.Please wait while we process your request"
                  )}
                </div>
              </div>
            </div>
          )}
          <div className="row child-1">
            <div className={`col-md-6 ${fromMeeting ? "w-100" : ""}`}>
              {/* {fromMeeting ? ( */}
              <>
                <div className="title mb-1">
                  <Link
                    to={`/meeting`}
                    // style={{ textDecoration: "none", color: "#8590a3" }}
                  >
                    Agenda
                  </Link>
                  <span> / </span>

                  <Link
                    to={{
                      pathname: `/invitiesToMeeting/${meeting?.destination_id}`,
                    }}
                    // style={{ textDecoration: "none", color: "#8590a3" }}
                  >
                    {meeting?.objective}
                  </Link>
                </div>

                <div className="invite-header">
                  <span
                    className="content-heading-title d-flex align-items-center"
                    style={{ marginTop: fromMeeting && "0" }}
                  >
                    {meeting?.title}
                    <span
                      className="ms-2 cursor-pointer"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleEditTitle(meeting)}
                    >
                      <RiEditBoxLine size={20} />
                    </span>

                    {meeting?.status === "closed" && (
                      <span className="mx-2 badge inprogrss">
                        {t("badge.finished")}
                      </span>
                    )}
                    {meeting?.status === "abort" && (
                      <span className="mx-2 badge late">
                        {t("badge.cancel")}
                      </span>
                    )}
                    {meeting?.status === "in_progress" && (
                      <span className="mx-2 badge inprogrss">
                        {t("badge.inprogress")}
                      </span>
                    )}
                  </span>

                  <div className="play-btn-container">
                    {meeting?.status !== "abort" &&
                      parseInt(meeting?.user_id) ===
                        parseInt(sessionStorage.getItem("user_id")) && (
                        <Button
                          className="btn play-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            const currentURL = `/destination/${meeting?.unique_id}/${meeting?.id}`;
                            copy(currentURL);
                            openLinkInNewTab(currentURL);
                            // navigate(currentURL, { state: fromMeeting });
                          }}
                          disabled={transcriptLoading || summaryLoading}
                        >
                          {transcriptLoading || summaryLoading
                            ? t("presentation.summarizing")
                            : t("presentation.generateLink")}

                          <FaArrowRight
                            size={12}
                            style={{
                              marginLeft: ".5rem",
                              fontWeight: 700,
                            }}
                          />
                        </Button>
                      )}
                    <Dropdown className="dropdown">
                      {
                        // Check if the logged-in user is in the guides array
                        (meeting?.steps?.some(
                          (guide) => guide?.userPID === parseInt(loggedInUserId)
                        ) ||
                          // Check if all participants have user_id equal to meeting.user.id
                          meeting?.user?.id === parseInt(loggedInUserId)) && (
                          <Dropdown.Toggle
                            variant="success"
                            id="dropdown-basic"
                          >
                            <BiDotsVerticalRounded
                              color="black"
                              size={"25px"}
                            />
                          </Dropdown.Toggle>
                        )
                      }

                      {
                        // Check if the logged-in user is in the guides array
                        meeting?.steps?.some(
                          (guide) => guide?.userPID === parseInt(loggedInUserId)
                        ) ||
                        // Check if all participants have user_id equal to meeting.user.id
                        meeting?.user?.id === parseInt(loggedInUserId) ? (
                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={(e) => {
                                e.stopPropagation();
                                handleCopy(
                                  setFormState,
                                  meeting,
                                  t,
                                  handleShow,
                                  setMeeting1,
                                  setCheckId,
                                  setIsDuplicate,
                                  setMeeting,
                                  setIsLoading,
                                  setStatus,
                                  updateSteps,
                                  meeting?.steps
                                );
                              }}
                              disabled={isDisabled}
                            >
                              <MdContentCopy size={"18px"} /> &nbsp;
                              {t("dropdown.Duplicate")}
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={(e) => handleChangePrivacy(meeting)}
                            >
                              <RiEditBoxLine size={"18px"} /> &nbsp;{" "}
                              {t("dropdown.change Privacy")}
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={(e) => handleChangeContext(meeting)}
                            >
                              <RiEditBoxLine size={"18px"} /> &nbsp;{" "}
                              {t("dropdown.change Context")}
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={(e) => handleChangeOptions(meeting)}
                            >
                              <RiEditBoxLine size={"18px"} /> &nbsp;{" "}
                              {t("dropdown.change Options")}
                            </Dropdown.Item>
                              <Dropdown.Item
                                onClick={(e) => sendReport(meeting)}
                              >
                                <MdOutlineShare size={"18px"} /> &nbsp;{" "}
                                {t("Shareby")}
                              </Dropdown.Item>
                            <hr
                              style={{
                                margin: "10px 0 0 0",
                                padding: "2px",
                              }}
                            />

                            <Dropdown.Item
                              // onClick={(e) => {
                              //   e.stopPropagation();
                              //   handleDelete(meeting.id);
                              // }}
                              onClick={(e) => handleDeleteClick(e, meeting?.id)}
                              disabled={isDisabled}
                            >
                              <AiOutlineDelete size={"20px"} color="red" />
                              &nbsp; {t("dropdown.Delete")}
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        ) : (
                          <>
                            <Button
                              className="btn play-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                const currentURL = `/destination/${meeting?.unique_id}/${meeting?.id}`;
                                copy(currentURL);
                                openLinkInNewTab(currentURL);
                              }}
                              disabled={isDisabled}
                            >
                              <RiPresentationFill size={"20px"} /> &nbsp;
                              {t("presentation.generateLink")}
                            </Button>
                          </>
                        )
                      }
                    </Dropdown>
                  </div>
                </div>

                <div className="items mt-0 mt-md-2 audio-items">
                  <div className="type">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.33333 2.99984C8.33333 3.3665 8.20289 3.6805 7.942 3.94184C7.68111 4.20317 7.36711 4.33362 7 4.33317C6.85556 4.33317 6.72222 4.31362 6.6 4.2745C6.47778 4.23539 6.35556 4.17162 6.23333 4.08317C5.96667 4.17206 5.75289 4.33317 5.592 4.5665C5.43111 4.79984 5.35044 5.05539 5.35 5.33317H14L13.3333 9.99984H10.0667V8.6665H12.1833C12.2389 8.33317 12.2862 7.99984 12.3253 7.6665C12.3644 7.33317 12.4116 6.99984 12.4667 6.6665H3.53333C3.58889 6.99984 3.63622 7.33317 3.67533 7.6665C3.71444 7.99984 3.76156 8.33317 3.81667 8.6665H5.93333V9.99984H2.66667L2 5.33317H4C4 4.78873 4.15 4.29428 4.45 3.84984C4.75 3.40539 5.15556 3.07762 5.66667 2.8665C5.7 2.52206 5.84444 2.23606 6.1 2.0085C6.35556 1.78095 6.65556 1.66695 7 1.6665C7.36667 1.6665 7.68067 1.79717 7.942 2.0585C8.20333 2.31984 8.33378 2.63362 8.33333 2.99984ZM6.51667 12.6665H9.48333L9.86667 8.6665H6.13333L6.51667 12.6665ZM5.33333 13.9998L4.83333 8.79984C4.78889 8.41095 4.9 8.06939 5.16667 7.77517C5.43333 7.48095 5.76111 7.33362 6.15 7.33317H9.85C10.2389 7.33317 10.5667 7.4805 10.8333 7.77517C11.1 8.06984 11.2111 8.41139 11.1667 8.79984L10.6667 13.9998H5.33333Z"
                        fill="#8590A3"
                      />
                    </svg>
                    {/* <span className="time">{meeting?.type}</span> */}
                    <span className="time">
                      {meeting?.solution
                        ? meeting?.solution?.title
                        : meeting?.type === "Google Agenda Event"
                        ? "Google Agenda Event"
                        : t(`types.${meeting?.type}`)}
                    </span>
                  </div>
                  {/* <div className="priority">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M12.346 6.79075C12.3618 6.77463 12.3808 6.76199 12.4018 6.75362C12.4228 6.74526 12.4453 6.74137 12.4679 6.74218C12.4905 6.743 12.5126 6.74851 12.533 6.75836C12.5533 6.76821 12.5714 6.78219 12.586 6.79941C13.4616 7.83748 13.9592 9.1419 13.9973 10.4994C13.9978 10.5213 13.9938 10.543 13.9857 10.5633C13.9776 10.5835 13.9656 10.602 13.9502 10.6175C13.9349 10.6331 13.9165 10.6454 13.8964 10.6537C13.8762 10.6621 13.8545 10.6663 13.8327 10.6661H10.8293C10.7849 10.6653 10.7424 10.6476 10.7104 10.6167C10.6785 10.5857 10.6595 10.5438 10.6573 10.4994C10.627 10.0165 10.4657 9.5509 10.1907 9.15275C10.167 9.11952 10.1557 9.07907 10.1588 9.0384C10.1618 8.99773 10.179 8.95941 10.2073 8.93008L12.346 6.79075ZM11.866 6.07941C11.9393 6.14075 11.9427 6.25141 11.8753 6.31941L9.73532 8.45875C9.70603 8.48691 9.66784 8.50399 9.62732 8.50703C9.5868 8.51007 9.54649 8.49889 9.51332 8.47541C9.20249 8.26075 8.84958 8.11463 8.47799 8.04675C8.43781 8.03991 8.4013 8.01924 8.37475 7.98831C8.34821 7.95739 8.33332 7.91816 8.33265 7.87741V4.85208C8.33265 4.75608 8.41265 4.68008 8.50865 4.68808C9.74476 4.79382 10.9177 5.27947 11.866 6.07941ZM7.66599 4.85275C7.66625 4.8301 7.66178 4.80765 7.65287 4.78684C7.64395 4.76602 7.63079 4.74729 7.61423 4.73186C7.59766 4.71642 7.57805 4.70461 7.55666 4.69719C7.53526 4.68976 7.51256 4.68689 7.48999 4.68875C6.25395 4.7943 5.08102 5.28038 4.13265 6.08008C4.11544 6.09471 4.10146 6.11276 4.0916 6.1331C4.08175 6.15343 4.07624 6.17559 4.07542 6.19817C4.07461 6.22075 4.0785 6.24325 4.08687 6.26424C4.09523 6.28523 4.10787 6.30424 4.12399 6.32008L6.26399 8.45941C6.29315 8.48781 6.33137 8.50505 6.37196 8.5081C6.41255 8.51114 6.45292 8.49981 6.48599 8.47608C6.7968 8.2614 7.14972 8.11528 7.52132 8.04741C7.56149 8.04057 7.59801 8.0199 7.62455 7.98898C7.65109 7.95806 7.66599 7.91883 7.66665 7.87808L7.66599 4.85275ZM5.80865 9.15275C5.83205 9.11951 5.84311 9.07915 5.83995 9.03862C5.83679 8.9981 5.81959 8.95995 5.79132 8.93075L3.65199 6.79075C3.63611 6.77467 3.61705 6.76207 3.59604 6.75377C3.57502 6.74546 3.55251 6.74163 3.52993 6.74251C3.50735 6.74338 3.4852 6.74896 3.46489 6.75887C3.44459 6.76878 3.42657 6.78282 3.41199 6.80008C2.53685 7.83833 2.03977 9.14273 2.00199 10.5001C2.00154 10.5219 2.00546 10.5435 2.01351 10.5638C2.02156 10.584 2.03358 10.6024 2.04886 10.618C2.06415 10.6335 2.08238 10.6458 2.1025 10.6542C2.12261 10.6626 2.1442 10.6668 2.16599 10.6667H5.16932C5.26132 10.6667 5.33599 10.5927 5.34132 10.5001C5.37132 10.0154 5.53465 9.54941 5.80799 9.15341"
                          fill="#8590A3"
                          fill-opacity="0.25"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.33203 7.87077C8.33203 7.95477 8.3947 8.02477 8.47737 8.0401C8.85073 8.10802 9.20529 8.25485 9.51737 8.47077C9.55067 8.49434 9.59116 8.50551 9.63183 8.50234C9.67251 8.49918 9.71079 8.48187 9.74004 8.45344L12.3467 5.84677C12.3628 5.83102 12.3756 5.8121 12.384 5.79119C12.3925 5.77029 12.3966 5.74786 12.3959 5.72531C12.3953 5.70276 12.39 5.68059 12.3804 5.66019C12.3708 5.63979 12.357 5.6216 12.34 5.60677C11.2636 4.6834 9.92079 4.12735 8.5067 4.01944C8.48426 4.01788 8.46174 4.02097 8.44055 4.02851C8.41936 4.03606 8.39996 4.04791 8.38356 4.0633C8.36717 4.0787 8.35412 4.09732 8.34526 4.11799C8.33639 4.13866 8.33189 4.16094 8.33203 4.18344V7.87077Z"
                          fill="#8590A3"
                        />
                      </svg>
                      <span className="time">
                        {t(
                          `meeting.newMeeting.options.priorities.${meeting?.priority}`
                        )}
                      </span>
                    </div> */}

                  {meeting?.prise_de_notes === "Automatic" &&
                    (loading ? (
                      <div style={{ width: "20%", margin: "20px 0" }}>
                        <ProgressBar animated now={45} />
                      </div>
                    ) : meetAudio === null ? (
                      <div
                        style={{
                          margin: "20px 0",
                          fontWeight: "bold",
                          color: "red",
                        }}
                      >
                        {t("Audio not found")}
                        <label
                          htmlFor="audio-upload"
                          style={{
                            marginLeft: "10px",
                            cursor: "pointer",
                            color: "black",
                          }}
                        >
                          <FaRegFileAudio size={20} />{" "}
                          {t("note_translation.Upload Audio")}
                        </label>
                        <input
                          id="audio-upload"
                          type="file"
                          accept="audio/*"
                          style={{ display: "none" }}
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) {
                              // You can add your audio upload logic here
                              console.log("Audio file selected:", file);
                              uploadAudioToCloudinary(file);
                            }
                          }}
                        />
                      </div>
                    ) : (
                      <audio
                        controls
                        src={meetingAudio || meetAudio || meeting?.voice_notes}
                      >
                        Your browser does not support the audio element.
                      </audio>
                    ))}

                  {/* //old code but correct */}
                  {/* {meeting?.prise_de_notes === "Automatic" &&
                      (loading ? (
                        <div style={{ width: "20%", margin: "20px 0" }}>
                          <ProgressBar animated now={45} />
                        </div>
                      ) : (
                        <audio
                          controls
                          src={meetingAudio || meeting?.voice_notes}
                        >
                          Your browser does not support the audio element.
                        </audio>
                      ))} */}
                </div>
              </>
              <div className="d-flex align-items-center gap-2 content-body present-invite-body mt-3 mt-lg-3">
                <div className="d-flex align-items-center gap-2">
                  <img
                    src="/Assets/invite-date.svg"
                    height="28px"
                    width="28px"
                  />

                  <>
                    {meeting?.type === "Action1" ||
                    meeting?.type === "Newsletter" ? (
                      <>
                        <span className="fw-bold formate-date">
                          {formattedStartDate} -
                        </span>

                        {meeting?.status === "abort" ? (
                          <span className="fw-bold formate-date">
                            {meeting?.abort_end_time
                              ? abortMeetingTime(
                                  meeting?.abort_end_time,
                                  "DD/MM/yyyy",
                                  meeting?.timezone
                                )
                              : estimateDate}
                          </span>
                        ) : (
                          <span className="fw-bold formate-date">
                            {estimateDate}
                          </span>
                        )}
                      </>
                    ) : meeting?.type === "Special" ||
                      meeting?.type === "Law" ? (
                      <>
                        <span className="fw-bold formate-date">
                          {formattedStartDate}
                          &nbsp; {t("at")}
                        </span>

                        <span className="fw-bold formate-date">
                          {convertTo12HourFormat(
                            meeting?.start_time,
                            meeting?.date,
                            meeting?.steps,
                            meeting?.timezone
                          )}{" "}
                          -{" "}
                        </span>

                        <span className="fw-bold formate-date">
                          {estimateDate}
                          &nbsp; {t("at")}
                        </span>
                        <span className="fw-bold formate-date">
                          {specialMeetingEndTime(
                            meeting?.start_time,
                            meeting?.date,
                            meeting?.steps,
                            meeting?.timezone
                          )}
                        </span>
                      </>
                    ) : (
                      <>
                        <span className="fw-bold formate-date">
                          {formattedStartDate} &nbsp; {t("at")} &nbsp;
                          {convertTo12HourFormat(
                            meeting?.starts_at ||
                              meeting?.steps[0]?.current_time ||
                              meeting?.start_time,
                            meeting?.date,
                            meeting?.steps,
                            meeting?.timezone
                          )}{" "}
                          -{" "}
                        </span>
                        {meeting?.status === "abort" ? (
                          <>
                            {meeting?.abort_end_time ? (
                              <span className="fw-bold formate-date">
                                {abortMeetingTime(
                                  meeting?.abort_end_time,
                                  "DD/MM/yyyy",
                                  meeting?.timezone
                                )}
                                &nbsp; {t("at")} &nbsp;
                                {abortMeetingTime(
                                  meeting?.abort_end_time,
                                  "HH[h]mm",
                                  meeting?.timezone
                                ) || "N/A"}
                              </span>
                            ) : (
                              <span className="fw-bold formate-date">
                                {estimateDate}
                                &nbsp; {t("at")} &nbsp;
                                {estimateTime || "N/A"}
                              </span>
                            )}
                          </>
                        ) : (
                          <span className="fw-bold formate-date">
                            {estimateDate}
                            &nbsp; {t("at")} &nbsp;
                            {estimateTime || "N/A"}
                          </span>
                        )}
                      </>
                    )}
                  </>

                  <span className="fw-bold">
                    {getTimezoneSymbol(localStorage.getItem("timezone"))}
                  </span>
                </div>
              </div>

              {/* Location */}
              <div>
                {(meeting?.location && meeting?.location !== "None") ||
                (meeting?.agenda && meeting?.agenda !== "None") ? (
                  <div className="d-flex gap-4 align-items-center mt-2 mb-2">
                    {meeting?.location && meeting?.location !== "None" && (
                      <p className="d-flex gap-2 justify-content-start ps-0 fw-bold align-items-center mb-0">
                        <span>
                          <svg
                            width="28px"
                            height="28px"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              {" "}
                              <path
                                d="M2 11.9556C2 8.47078 2 6.7284 2.67818 5.39739C3.27473 4.22661 4.22661 3.27473 5.39739 2.67818C6.7284 2 8.47078 2 11.9556 2H20.0444C23.5292 2 25.2716 2 26.6026 2.67818C27.7734 3.27473 28.7253 4.22661 29.3218 5.39739C30 6.7284 30 8.47078 30 11.9556V20.0444C30 23.5292 30 25.2716 29.3218 26.6026C28.7253 27.7734 27.7734 28.7253 26.6026 29.3218C25.2716 30 23.5292 30 20.0444 30H11.9556C8.47078 30 6.7284 30 5.39739 29.3218C4.22661 28.7253 3.27473 27.7734 2.67818 26.6026C2 25.2716 2 23.5292 2 20.0444V11.9556Z"
                                fill="white"
                              ></path>{" "}
                              <path
                                d="M5 23.5601C5 24.3557 5.64998 25.0001 6.45081 25.0001H6.47166C5.65857 25.0001 5 24.3557 5 23.5601Z"
                                fill="#FBBC05"
                              ></path>{" "}
                              <path
                                d="M17.4678 12.4V16.1596L22.5364 12.0712V8.43999C22.5364 7.6444 21.8864 7 21.0856 7H10.1045L10.0947 12.4H17.4678Z"
                                fill="#FBBC05"
                              ></path>{" "}
                              <path
                                d="M17.4671 19.9207H10.0818L10.0732 25.0003H21.085C21.887 25.0003 22.5358 24.3559 22.5358 23.5603V20.2819L17.4671 16.1611V19.9207Z"
                                fill="#34A853"
                              ></path>{" "}
                              <path
                                d="M10.1042 7L5 12.4H10.0956L10.1042 7Z"
                                fill="#EA4335"
                              ></path>{" "}
                              <path
                                d="M5 19.9204V23.56C5 24.3556 5.65857 25 6.47166 25H10.0736L10.0821 19.9204H5Z"
                                fill="#1967D2"
                              ></path>{" "}
                              <path
                                d="M10.0956 12.3999H5V19.9203H10.0821L10.0956 12.3999Z"
                                fill="#4285F4"
                              ></path>{" "}
                              <path
                                d="M26.9926 22.2796V9.9197C26.7068 8.27931 24.9077 10.1597 24.9077 10.1597L22.5371 12.0713V20.2804L25.9305 23.0392C27.1557 23.2 26.9926 22.2796 26.9926 22.2796Z"
                                fill="#34A853"
                              ></path>{" "}
                              <path
                                d="M17.4678 16.1594L22.5377 20.2814V12.0723L17.4678 16.1594Z"
                                fill="#188038"
                              ></path>{" "}
                            </g>
                          </svg>
                        </span>
                        <span className="solutioncards option-text">
                          {meeting?.user?.google_full_name}
                        </span>
                      </p>
                    )}
                    {meeting?.agenda && meeting?.agenda !== "None" && (
                      <p className="d-flex gap-2 justify-content-start ps-0 fw-bold align-items-center mb-0">
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            aria-label="Google Calendar"
                            role="img"
                            viewBox="0 0 512 512"
                            width="28px"
                            height="28px"
                            fill="#000000"
                          >
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              <rect
                                width="512"
                                height="512"
                                rx="15%"
                                fill="#ffffff"
                              ></rect>
                              <path
                                d="M100 340h74V174H340v-74H137Q100 100 100 135"
                                fill="#4285f4"
                              ></path>
                              <path
                                d="M338 100v76h74v-41q0-35-35-35"
                                fill="#1967d2"
                              ></path>
                              <path
                                d="M338 174h74V338h-74"
                                fill="#fbbc04"
                              ></path>
                              <path
                                d="M100 338v39q0 35 35 35h41v-74"
                                fill="#188038"
                              ></path>
                              <path
                                d="M174 338H338v74H174"
                                fill="#34a853"
                              ></path>
                              <path d="M338 412v-74h74" fill="#ea4335"></path>
                              <path
                                d="M204 229a25 22 1 1 1 25 27h-9h9a25 22 1 1 1-25 27M270 231l27-19h4v-7V308"
                                stroke="#4285f4"
                                stroke-width="15"
                                stroke-linejoin="bevel"
                                fill="none"
                              ></path>
                            </g>
                          </svg>
                        </span>
                        <span className="solutioncards option-text">
                          {meeting?.user?.google_full_name}
                        </span>
                      </p>
                    )}
                  </div>
                ) : null}
                <div className="ps-0">
                  {meeting?.address ? (
                    <p className="d-flex gap-2 align-items-center justify-content-start ps-0 ms-0 mt-2">
                      <FaLocationDot size={25} />
                      <span>{meeting?.address}</span>
                    </p>
                  ) : null}
                </div>
                {meeting?.room_details ? (
                  <div>
                    <p className="d-flex gap-2 mt-2 justify-content-start align-items-top ps-0">
                      <BsPersonWorkspace size={25} />
                      <p className="m-0">
                        {meeting?.room_details && meeting?.room_details}
                      </p>
                    </p>
                  </div>
                ) : null}
                {meeting?.phone ? ( // Check if the phone field exists
                  <div>
                    <p className="d-flex gap-2 align-items-center justify-content-start ps-0 mt-2">
                      <span>
                        <FaPhoneAlt size={25} />
                      </span>
                      <a
                        href={`tel:${meeting.phone}`}
                        className="text-decoration-none"
                      >
                        <span className="">{meeting.phone}</span>{" "}
                        {/* Display the phone number */}
                      </a>
                    </p>
                  </div>
                ) : null}
              </div>

              {/* Options */}
              <div className="row mt-2">
                <div className="col-md-12 d-flex align-items-center gap-3">
                  {meeting?.prise_de_notes === "Automatic" && (
                    <>
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="28"
                          viewBox="0 0 28 28"
                          fill="none"
                        >
                          <g filter="url(#filter0_d_1_1154)">
                            <circle
                              cx="14"
                              cy="12"
                              r="10"
                              stroke="url(#paint0_linear_1_1154)"
                              strokeWidth="4"
                            />
                          </g>
                          <defs>
                            <filter
                              id="filter0_d_1_1154"
                              x="0"
                              y="0"
                              width="28"
                              height="28"
                              filterUnits="userSpaceOnUse"
                              colorInterpolationFilters="sRGB"
                            >
                              <feFlood
                                floodOpacity="0"
                                result="BackgroundImageFix"
                              />
                              <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                              />
                              <feOffset dy="2" />
                              <feGaussianBlur stdDeviation="1" />
                              <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                              />
                              <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow_1_1154"
                              />
                              <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_dropShadow_1_1154"
                                result="shape"
                              />
                            </filter>
                            <linearGradient
                              id="paint0_linear_1_1154"
                              x1="14"
                              y1="0"
                              x2="20.375"
                              y2="21.75"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#B11FAB" />
                              <stop offset="0.514" stopColor="#56E8F1" />
                              <stop offset="1" stopColor="#2F47C1" />
                            </linearGradient>
                          </defs>
                        </svg>
                        <span className="solutioncards option-text">
                          {t("meeting.formState.Automatic note taking")}
                        </span>
                      </div>
                    </>
                  )}
                  {meeting?.note_taker === true && (
                    <>
                      <div className="d-flex align-items-center gap-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28px"
                          height="28px"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#3D57B5"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g
                            id="SVGRepo_tracerCarrier"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></g>
                          <g id="SVGRepo_iconCarrier">
                            {" "}
                            <rect
                              x="3"
                              y="11"
                              width="18"
                              height="10"
                              rx="2"
                            ></rect>{" "}
                            <circle cx="12" cy="5" r="2"></circle>{" "}
                            <path d="M12 7v4"></path>{" "}
                            <line x1="8" y1="16" x2="8" y2="16"></line>{" "}
                            <line x1="16" y1="16" x2="16" y2="16"></line>{" "}
                          </g>
                        </svg>
                        <span className="solutioncards option-text">
                          {t("meeting.formState.Note Taker")}
                        </span>
                      </div>
                    </>
                  )}

                  {meeting?.alarm === true && (
                    <>
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="24"
                          viewBox="0 0 25 24"
                          fill="none"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M12.5001 1.35999C12.2879 1.35999 12.0844 1.44427 11.9344 1.5943C11.7844 1.74433 11.7001 1.94781 11.7001 2.15999V5.63519C11.7001 5.84736 11.7844 6.05084 11.9344 6.20087C12.0844 6.3509 12.2879 6.43519 12.5001 6.43519C12.7122 6.43519 12.9157 6.3509 13.0658 6.20087C13.2158 6.05084 13.3001 5.84736 13.3001 5.63519V2.99519C15.3173 3.17457 17.2159 4.02613 18.6915 5.41333C20.167 6.80054 21.134 8.64304 21.4373 10.6454C21.7407 12.6478 21.363 14.694 20.3646 16.4561C19.3662 18.2181 17.8051 19.5939 15.9315 20.3628C14.058 21.1317 11.9805 21.2492 10.0321 20.6965C8.08379 20.1437 6.37749 18.9528 5.1868 17.3145C3.99611 15.6763 3.39001 13.6857 3.46567 11.6619C3.54134 9.63811 4.29438 7.69833 5.60407 6.15358C5.67546 6.07402 5.73018 5.98095 5.765 5.87989C5.79981 5.77882 5.81402 5.6718 5.80678 5.56514C5.79954 5.45849 5.771 5.35437 5.72285 5.25893C5.67469 5.1635 5.6079 5.07868 5.52641 5.00949C5.44493 4.9403 5.3504 4.88815 5.24842 4.8561C5.14644 4.82406 5.03907 4.81278 4.93265 4.82293C4.82624 4.83308 4.72293 4.86446 4.62885 4.91521C4.53476 4.96595 4.4518 5.03504 4.38487 5.11839C2.81701 6.96726 1.92749 9.29609 1.86357 11.7194C1.79964 14.1427 2.56513 16.5152 4.03333 18.4442C5.50153 20.3731 7.58441 21.7429 9.9372 22.3268C12.29 22.9106 14.7716 22.6736 16.9713 21.6548C19.171 20.6361 20.9569 18.8967 22.0333 16.7247C23.1098 14.5526 23.4122 12.0781 22.8907 9.71074C22.3691 7.34336 21.0548 5.22506 19.1652 3.70646C17.2757 2.18787 14.9242 1.36003 12.5001 1.35999ZM11.2841 12.928L7.25847 7.31679C7.20487 7.23976 7.18006 7.14634 7.18838 7.05287C7.19669 6.9594 7.23761 6.87183 7.30396 6.80548C7.37031 6.73912 7.45789 6.69821 7.55135 6.68989C7.64482 6.68158 7.73824 6.70639 7.81527 6.75999L13.4297 10.784C13.6103 10.914 13.7605 11.0818 13.8699 11.2757C13.9793 11.4695 14.0453 11.6848 14.0632 11.9067C14.0812 12.1286 14.0507 12.3517 13.9738 12.5606C13.897 12.7695 13.7757 12.9592 13.6183 13.1166C13.4609 13.274 13.2712 13.3953 13.0623 13.4722C12.8534 13.549 12.6303 13.5795 12.4084 13.5615C12.1865 13.5436 11.9712 13.4776 11.7773 13.3682C11.5835 13.2588 11.4157 13.1086 11.2857 12.928"
                            fill="#3D57B5"
                          />
                        </svg>
                        <span
                          className="solutioncards"
                          style={{ color: "#3D57B5" }}
                        >
                          {t("meeting.formState.Beep alarm")}
                        </span>
                      </div>
                    </>
                  )}

                  {/* {meeting?.share_by === "email" && (
                    <>
                      <div>
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 30 30"
                            width="30px"
                            height="30px"
                          >
                            <path
                              d="M 23 3 A 4 4 0 0 0 19 7 A 4 4 0 0 0 19.09375 7.8359375 L 10.011719 12.376953 A 4 4 0 0 0 7 11 A 4 4 0 0 0 3 15 A 4 4 0 0 0 7 19 A 4 4 0 0 0 10.013672 17.625 L 19.089844 22.164062 A 4 4 0 0 0 19 23 A 4 4 0 0 0 23 27 A 4 4 0 0 0 27 23 A 4 4 0 0 0 23 19 A 4 4 0 0 0 19.986328 20.375 L 10.910156 15.835938 A 4 4 0 0 0 11 15 A 4 4 0 0 0 10.90625 14.166016 L 19.988281 9.625 A 4 4 0 0 0 23 11 A 4 4 0 0 0 27 7 A 4 4 0 0 0 23 3 z"
                              fill="#3D57B5"
                            />
                          </svg>
                        </span>
                        {t("Shareby")}
                      </div>
                    </>
                  )} */}
                </div>
              </div>

              {/* Star Ratings */}
              {meeting?.meeting_feedbacks?.length > 0 && meeting?.feedback && (
                <div className="row">
                  <div className="col-md-12 mt-2 ms-1 d-flex align-items-center gap-2">
                    <div className="d-flex align-items-center">
                      {[...Array(5)].map((_, index) => (
                        <FaStar
                          key={index}
                          color={
                            index < Math.round(averageRating)
                              ? "#FFD700"
                              : "#D3D3D3"
                          }
                          size={20}
                          style={{ marginRight: 1 }}
                        />
                      ))}
                    </div>

                    <span className="time">{averageRating.toFixed(1)}</span>
                    <span className="time">{`(${
                      meeting?.meeting_feedbacks?.length
                    } ${
                      meeting?.meeting_feedbacks?.length > 1 ? "Votes" : "Vote"
                    })`}</span>
                  </div>
                </div>
              )}
              {/* Casting Type */}
              {/* Privacy */}
              <div className="row">
                <div className="col-md-12 mt-2 ms-1 d-flex align-items-center gap-3">
                  <span
                    style={{
                      fontFamily: "Inter",
                      fontSize: "12px",
                      fontWeight: 400,
                      lineHeight: "14.52px",
                      textAlign: "left",
                      color: "#8590a3",
                    }}
                  >
                    {t("Privacy")}:
                  </span>
                  <div className="">
                    <div className="d-flex align-items-center flex-wrap">
                      {meeting?.moment_privacy === "public" ? (
                        <Avatar
                          src="/Assets/Tek.png"
                          style={{ borderRadius: "0" }}
                        />
                      ) : meeting?.moment_privacy === "team" ? (
                        <Avatar.Group>
                          {meeting?.moment_privacy_teams_data?.map((item) => {
                            return (
                              <>
                                <Tooltip title={item?.name} placement="top">
                                  <Avatar
                                    size="large"
                                    src={
                                      item?.logo?.startsWith("http")
                                        ? item.logo
                                        : Assets_URL + "/" + item.logo
                                    }
                                  />
                                </Tooltip>
                              </>
                            );
                          })}
                        </Avatar.Group>
                      ) : meeting?.moment_privacy === "participant only" ? (
                        <Avatar.Group>
                          {meeting?.user_with_participants?.map((item) => {
                            return (
                              <>
                                <Tooltip
                                  title={item?.full_name}
                                  placement="top"
                                >
                                  <Avatar
                                    size="large"
                                    src={
                                      item?.participant_image?.startsWith(
                                        "http"
                                      )
                                        ? item.participant_image
                                        : Assets_URL +
                                          "/" +
                                          item.participant_image
                                    }
                                  />
                                </Tooltip>
                              </>
                            );
                          })}
                        </Avatar.Group>
                      ) : meeting?.moment_privacy === "tektime members" ? (
                        <img
                          src={
                            meeting?.user?.enterprise?.logo?.startsWith("http")
                              ? meeting?.user?.enterprise?.logo
                              : Assets_URL +
                                "/" +
                                meeting?.user?.enterprise?.logo
                          }
                          alt="Logo"
                          style={{
                            width: "30px",
                            height: "30px",
                            objectFit: "fill",
                            borderRadius: "50%",
                          }}
                        /> //   title={meeting?.user?.enterprise?.name} // <Tooltip
                      ) : //   placement="top"
                      // >
                      //   <img
                      //     src={
                      //       meeting?.user?.enterprise?.logo?.startsWith(
                      //         "http"
                      //       )
                      //         ? meeting?.user?.enterprise?.logo
                      //         : Assets_URL +
                      //           "/" +
                      //           meeting?.user?.enterprise?.logo
                      //     }
                      //     alt="Logo"
                      //     style={{
                      //       width: "30px",
                      //       height: "30px",
                      //       objectFit: "fill",
                      //       borderRadius: "50%",
                      //     }}
                      //   />
                      // </Tooltip>
                      meeting?.moment_privacy === "enterprise" ? (
                        <Tooltip
                          title={meeting?.user?.enterprise?.name}
                          placement="top"
                        >
                          <img
                            src={
                              meeting?.user?.enterprise?.logo?.startsWith(
                                "http"
                              )
                                ? meeting?.user?.enterprise?.logo
                                : Assets_URL +
                                  "/" +
                                  meeting?.user?.enterprise?.logo
                            }
                            alt="Logo"
                            style={{
                              width: "30px",
                              height: "30px",
                              objectFit: "fill",
                              borderRadius: "50%",
                            }}
                          />
                        </Tooltip>
                      ) : meeting?.moment_privacy === "password" ? (
                        <svg
                          width="37px"
                          height="36px"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g
                            id="SVGRepo_tracerCarrier"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></g>
                          <g id="SVGRepo_iconCarrier">
                            {" "}
                            <path
                              d="M7 10.0288C7.47142 10 8.05259 10 8.8 10H15.2C15.9474 10 16.5286 10 17 10.0288M7 10.0288C6.41168 10.0647 5.99429 10.1455 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C18.0057 10.1455 17.5883 10.0647 17 10.0288M7 10.0288V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V10.0288"
                              stroke="#000000"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>{" "}
                          </g>
                        </svg>
                      ) : (
                        <Tooltip
                          title={meeting?.user?.full_name}
                          placement="top"
                        >
                          <Avatar
                            src={
                              meeting?.user?.image.startsWith("users/")
                                ? Assets_URL + "/" + meeting?.user?.image
                                : meeting?.user?.image
                            }
                          />
                        </Tooltip>
                      )}

                      <span
                        className={`badge ms-2 ${
                          meeting?.moment_privacy === "private"
                            ? "solution-badge-red"
                            : meeting?.moment_privacy === "public"
                            ? "solution-badge-green"
                            : meeting?.moment_privacy === "enterprise" ||
                              meeting?.moment_privacy === "participant only" ||
                              meeting?.moment_privacy === "tektime members"
                            ? "solution-badge-blue"
                            : meeting?.moment_privacy === "password"
                            ? "solution-badge-red"
                            : "solution-badge-yellow"
                        }`}
                        style={{ padding: "3px 8px 3px 8px" }}
                      >
                        {meeting?.moment_privacy === "private"
                          ? t("solution.badge.private")
                          : meeting?.moment_privacy === "public"
                          ? t("solution.badge.public")
                          : meeting?.moment_privacy === "enterprise"
                          ? t("solution.badge.enterprise")
                          : meeting?.moment_privacy === "participant only"
                          ? t("solution.badge.participantOnly")
                          : meeting?.moment_privacy === "tektime members"
                          ? t("solution.badge.membersOnly")
                          : meeting?.moment_privacy === "password"
                          ? t("solution.badge.password")
                          : t("solution.badge.team")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="paragraph-parent my-0 mt-2 ms-1">
            <span className="paragraph paragraph-images">
              <div
                dangerouslySetInnerHTML={{
                  __html: meeting?.description || "",
                }}
              />
            </span>
          </div>

          {/* ...........HERE */}

          <div className="current_destinations clients-tab">
            <Tab.Container
              className="destination-tabs-container"
              activeKey={activeTab}
              onSelect={handleTabSelect}
            >
              <div className="row align-items-end tabs-header custom-tabs mt-5">
                <div className="col-md-10">
                  <Nav variant="tabs" className="d-flex flex-wrap gap-3">
                    {/* Contacts tab - ALWAYS include this */}
                    <Nav.Item key="casting" className="tab">
                      <Nav.Link eventKey="casting" className="custom-tab-link">
                        {t("Casting")}
                        <span
                          className={`${
                            activeTab === "casting" ? "future" : "draft"
                          } ms-2`}
                          style={{ padding: "4px 6px", borderRadius: "8px" }}
                        >
                          {meeting?.guides?.length +
                            meeting?.participants?.length || 0}
                        </span>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item key="steps" className="tab">
                      <Nav.Link eventKey="steps" className="custom-tab-link">
                        {t("steps")}
                        <span
                          className={`${
                            activeTab === "steps" ? "future" : "draft"
                          } ms-2`}
                          style={{ padding: "4px 6px", borderRadius: "8px" }}
                        >
                          {meeting?.steps?.length || 0}
                        </span>
                      </Nav.Link>
                    </Nav.Item>
                    {/* {meeting?.steps?.length > 1 && (
                      <Nav.Item key="stepNotes" className="tab">
                        <Nav.Link
                          eventKey="stepNotes"
                          className="custom-tab-link"
                        >
                          {meeting?.prise_de_notes === "Automatic"
                            ? t("Resume by step")
                            : t("Note by step")}
                        </Nav.Link>
                      </Nav.Item>
                    )} */}
                    {meeting?.prise_de_notes === "Automatic" && (
                      <Nav.Item key="meetingNotes" className="tab">
                        <Nav.Link
                          eventKey="meetingNotes"
                          className="custom-tab-link"
                        >
                          {t("Resume by moment")} :{" "}
                          {meeting?.type === "Google Agenda Event"
                            ? "Google Agenda Event"
                            : t(`types.${meeting.type}`)}
                        </Nav.Link>
                      </Nav.Item>
                    )}

                    <Nav.Item key="files" className="tab">
                      <Nav.Link eventKey="files" className="custom-tab-link">
                        {t("meeting.newMeeting.labels.file")}
                        <span className="ms-2">
                          {meeting?.meeting_files?.length || 0}
                        </span>
                      </Nav.Link>
                    </Nav.Item>
                    {meeting?.meeting_feedbacks?.length > 0 && (
                      <Nav.Item key="feedbacks" className="tab">
                        <Nav.Link
                          eventKey="feedbacks"
                          className="custom-tab-link"
                        >
                          {t("feedbacks")}
                          <span
                            className={`${
                              activeTab === "feedbacks" ? "future" : "draft"
                            } ms-2`}
                            style={{ padding: "4px 6px", borderRadius: "8px" }}
                          >
                            {meeting?.meeting_feedbacks?.length || 0}
                          </span>
                        </Nav.Link>
                      </Nav.Item>
                    )}

                    <Nav.Item key="discussion" className="tab">
                      <Nav.Link
                        eventKey="discussion"
                        className="custom-tab-link"
                      >
                        {t("meeting.newMeeting.labels.discussion")}
                        <span
                          className={`${
                            activeTab === "discussion" ? "future" : "draft"
                          } ms-2`}
                          style={{ padding: "4px 6px", borderRadius: "8px" }}
                        >
                          {meetingMessages?.length || 0}
                        </span>
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
                <div className="col-md-2 d-flex justify-content-end">
                  {activeTab === "files" && (
                    <div className="invite-buttons mt-3">
                      <input
                        type="file"
                        id="fileInput"
                        // accept="application/pdf"
                        accept="
                                          application/pdf,
                                          application/vnd.ms-excel,
                                          application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                                          application/vnd.ms-powerpoint,
                                          application/vnd.openxmlformats-officedocument.presentationml.presentation,
                                          application/msword,
                                          application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                                          image/png,
                                          image/webp
                                          video/mp4,
                                          video/x-msvideo,
                                          video/x-matroska,
                                          video/mpeg,
                                          video/quicktime"
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      />
                      <button
                        onClick={() => setShowFileModal(true)}
                        style={{
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: 600,
                          lineHeight: "24px",
                          textAlign: "left",
                          color: "#FFFFFF",
                          background: "#2C48AE",
                          border: 0,
                          outline: 0,
                          padding: "10px 16px",
                          borderRadius: "9px",
                          marginTop: "20px",
                        }}
                      >
                        <svg
                          width="20"
                          height="21"
                          viewBox="0 0 20 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10 0.457031C15.5228 0.457031 20 4.93418 20 10.457C20 15.9798 15.5228 20.457 10 20.457C4.47715 20.457 0 15.9798 0 10.457C0 4.93418 4.47715 0.457031 10 0.457031ZM10 1.95703C5.30558 1.95703 1.5 5.76261 1.5 10.457C1.5 15.1514 5.30558 18.957 10 18.957C14.6944 18.957 18.5 15.1514 18.5 10.457C18.5 5.76261 14.6944 1.95703 10 1.95703ZM10 5.45703C10.4142 5.45703 10.75 5.79282 10.75 6.20703V9.70703H14.25C14.6642 9.70703 15 10.0428 15 10.457C15 10.8712 14.6642 11.207 14.25 11.207H10.75V14.707C10.75 15.1212 10.4142 15.457 10 15.457C9.5858 15.457 9.25 15.1212 9.25 14.707V11.207H5.75C5.33579 11.207 5 10.8712 5 10.457C5 10.0428 5.33579 9.70703 5.75 9.70703H9.25V6.20703C9.25 5.79282 9.5858 5.45703 10 5.45703Z"
                            fill="white"
                          />
                        </svg>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        {t("addFile")}
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <Tab.Content className="">
                <Tab.Pane eventKey="casting">
                  {/* --------------Organisator */}
                  <div style={{ marginTop: "4rem" }}>
                    <h4 className="participant-heading-meeting">
                      {showOrgProfile && (
                        <IoArrowBackSharp
                          onClick={hideOrgShow}
                          size={25}
                          style={{
                            cursor: "pointer",
                            marginRight: "1rem",
                          }}
                        />
                      )}
                      {t("Creator")}
                    </h4>
                    <div
                      className="host"
                      style={{
                        background: showOrgProfile && "white",
                      }}
                    >
                      <HostCard
                        data={meeting?.user}
                        guides={meeting?.user_with_participants?.filter(
                          (item) => item?.email === meeting?.user?.email
                        )}
                        fromMeeting={fromMeeting}
                        handleShow={handleOrgShow}
                        handleHide={hideOrgShow}
                        showProfile={showOrgProfile}
                        meeting={meeting}
                      />
                    </div>
                  </div>

                  <div style={{ marginTop: "4rem" }}>
                    <h4
                      className={
                        fromMeeting
                          ? "participant-heading-meeting"
                          : "participant-heading"
                      }
                    >
                      {showHostProfile && (
                        <IoArrowBackSharp
                          onClick={hideHostShow}
                          size={25}
                          style={{
                            cursor: "pointer",
                            marginRight: "1rem",
                          }}
                        />
                      )}
                      {meeting?.guides?.length > 1 ? "Guides" : "Guide"}
                    </h4>
                    <div
                      className="host"
                      style={{ background: showHostProfile && "white" }}
                    >
                      <HostCard
                        data={meeting?.user}
                        fromMeeting={fromMeeting}
                        guides={meeting?.guides}
                        disabled={isDisabled}
                        handleShow={handleHostShow}
                        handleHide={hideHostShow}
                        showProfile={showHostProfile}
                        meeting={meeting}
                      />
                    </div>
                  </div>
                  {/* ------------------------------------------------ Participants------------------------------ */}
                  {meeting?.type !== "Newsletter" && (
                    <>
                      {meeting?.participants?.filter(
                        (item) =>
                          // item.isCreator === 0
                          !guideEmails.has(item.email)
                      )?.length > 0 && (
                        <div style={{ marginTop: "5rem" }}>
                          <h4
                            className={
                              fromMeeting
                                ? "participant-heading-meeting"
                                : "participant-heading"
                            }
                          >
                            {showProfile && (
                              <IoArrowBackSharp
                                onClick={hideShow}
                                size={25}
                                style={{
                                  cursor: "pointer",
                                  marginRight: "1rem",
                                }}
                              />
                            )}
                            {t("invite")}{" "}
                            <span>
                              {"(" +
                                meeting?.participants?.filter(
                                  (item) =>
                                    // item.isCreator === 0 &&
                                    item.attandance === 1 &&
                                    !guideEmails.has(item.email)
                                ).length +
                                "/" +
                                meeting?.participants?.filter(
                                  (item) =>
                                    // item.isCreator === 0 &&
                                    !guideEmails.has(item.email)
                                ).length +
                                ")"}
                            </span>
                          </h4>
                          <div
                            className="participant"
                            style={{ background: showProfile && "white" }}
                          >
                            <Participant
                              data={meeting?.participants}
                              meeting={meeting}
                              fromMeeting={fromMeeting}
                              disabled={isDisabled}
                              guides={meeting?.guides}
                              handleShow={handleShow1}
                              handleHide={hideShow}
                              showProfile={showProfile}
                              refreshedData={getReportMeeting}
                            />
                          </div>
                        </div>
                      )}
                    </>
                  )}

                  {meeting?.type === "Newsletter" && (
                    <>
                      <h4
                        className={
                          fromMeeting
                            ? "participant-heading-meeting"
                            : "participant-heading"
                        }
                      >
                        {t("Abonnés")}
                      </h4>
                      <div
                        className="participant"
                        style={{ background: showProfile && "white" }}
                      >
                        <div style={{ marginTop: "5rem" }}>
                          <SubscriberCard
                            subscribers={meeting?.newsletter_subscribers}
                            data={meeting?.newsletter_subscribers}
                            fromMeeting={fromMeeting}
                            meeting={meeting}
                            handleShow={handleShow1}
                            handleHide={hideShow}
                            showProfile={showProfile}
                          />
                        </div>
                      </div>
                    </>
                  )}
                </Tab.Pane>
                <Tab.Pane eventKey="steps">
                  {/* ------------------------------------------------ Steps */}
                  {meeting?.steps?.length > 0 && (
                    <div style={{ marginTop: "5rem", marginBottom: "3rem" }}>
                      <h4
                        className={`${
                          fromMeeting
                            ? "participant-heading-meeting"
                            : "participant-heading"
                        } d-flex align-items-center justify-content-between`}
                      >
                        {meeting?.steps?.length > 1 ? t("steps") : t("step")}
                        <span style={{ cursor: "pointer" }}>
                          <div className="toggle-button">
                            <button
                              className={`toggle-button-option ${
                                view === "grid" ? "active" : ""
                              }`}
                              onClick={() => handleToggle("grid")}
                            >
                              <div className="icon-grid" />
                              <FaList size={18} />
                            </button>
                            <button
                              className={`toggle-button-option ${
                                view === "list" ? "active" : ""
                              }`}
                              onClick={() => handleToggle("list")}
                            >
                              <div className="icon-list" />
                              <FaChartGantt size={20} />
                            </button>
                          </div>
                        </span>
                      </h4>

                      {view === "grid" ? (
                        <ReportStepCard
                          data={meeting?.steps}
                          users={{
                            ...meeting?.user,
                            firstName: meeting?.user?.name,
                            lastName: meeting?.user?.last_name,
                            image:
                              meeting?.user?.assigned_to_image ||
                              meeting?.user?.image ||
                              "/Assets/avatar.jpeg",
                          }}
                          fromMeeting={fromMeeting}
                          meeting={meeting}
                          refreshMeetings={getReportMeeting}
                        />
                      ) : (
                        <ReportStepChart
                          meetingId={meeting?.id}
                          data={meeting}
                          isDisabled={isDisabled}
                          meeting={meeting}
                          refreshMeetings={getReportMeeting}
                        />
                      )}
                    </div>
                  )}
                  {meeting?.type === "Special" || meeting?.type === "Law" ? (
                    <span
                      style={{
                        margin: "0 0 0 21px",
                        backgroundColor: "#F5F8FF",
                        // padding: "10px 12px",
                        padding: "20px 6rem 20px 12px",
                        borderRadius: "10px",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: 500,
                        lineHeight: "18px",
                        textAlign: "left",
                        // paddingRight: "6rem",
                      }}
                    >
                      {meeting?.estimate_time_time_taken &&
                        `${t(
                          "estimateFieldCompleted"
                        )}:  ${localizeEstimateTime(
                          meeting?.estimate_time_time_taken
                        )}`}
                    </span>
                  ) : (
                    <span
                      style={{
                        margin: "0 0 0 21px",
                        backgroundColor: "#F5F8FF",
                        // padding: "10px 12px",
                        padding: "20px 6rem 20px 12px",
                        borderRadius: "10px",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: 500,
                        lineHeight: "18px",
                        textAlign: "left",
                        // paddingRight: "6rem",
                      }}
                    >
                      {meeting?.estimate_time_time_taken &&
                        `${t(
                          "estimateFieldCompleted"
                        )}:  ${localizeEstimateTime(
                          meeting?.estimate_time_time_taken
                        )}`}
                    </span>
                  )}
                </Tab.Pane>

                {/* <Tab.Pane eventKey="stepNotes">
                  <div className="row d-flex justify-content-center">
                    <div className="col-md-12 mb-3">
                      {meeting?.steps?.length > 0 ? (
                        <div className="step-notes-container mt-5">
                          {meeting?.steps
                            .sort((a, b) => a.order_no - b.order_no)
                            .map((step) => (
                              <div
                                key={step.id}
                                className="step-note-card mb-4 p-3"
                                style={{
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "8px",
                                  backgroundColor: "#f9f9f9",
                                }}
                              >
                                <div className="step-header d-flex justify-content-between align-items-center mb-2">
                                  <div className="d-flex align-items-center">
                                    <span
                                      className="step-number me-2"
                                      style={{
                                        fontWeight: "bold",
                                        color: "#0026b1",
                                        fontSize: "18px",
                                      }}
                                    >
                                      {step.order_no}.
                                    </span>
                                    <h5
                                      className="step-title m-0"
                                      style={{
                                        fontWeight: "600",
                                        color: "#333",
                                      }}
                                    >
                                      {step.title}
                                    </h5>
                                  </div>

                                  {editingStepId !== step.id ? (
                                    <button
                                      onClick={() => {
                                        setEditingStepId(step.id);
                                        setCurrentNote(step.note || "");
                                      }}
                                      className="btn btn-sm"
                                      style={{
                                        background: "#0026b1",
                                        color: "white",
                                        padding: "5px 10px",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {meeting?.prise_de_notes === "Automatic"
                                        ? t("modify summary")
                                        : t("modify note")}
                                    </button>
                                  ) : (
                                    <div className="d-flex">
                                      <button
                                        onClick={() => handleSaveStepNote(step)}
                                        className="btn btn-sm me-2"
                                        style={{
                                          background: "#0026b1",
                                          color: "white",
                                          padding: "5px 10px",
                                          fontSize: "12px",
                                        }}
                                        disabled={isSavingNote}
                                      >
                                        {isSavingNote
                                          ? t("Validate")
                                          : t("Validate")}
                                      </button>
                                      <button
                                        onClick={() => setEditingStepId(null)}
                                        className="btn btn-sm"
                                        style={{
                                          background: "red",
                                          color: "white",
                                          padding: "5px 10px",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {t("Cancel")}
                                      </button>
                                    </div>
                                  )}
                                </div>

                                {editingStepId === step.id ? (
                                  <Editor
                                    apiKey={APIKEY}
                                    value={currentNote}
                                    onEditorChange={(content) =>
                                      setCurrentNote(content)
                                    }
                                    init={{
                                      height: 200,
                                      menubar: false,
                                      plugins:
                                        "autoresize lists link paste help wordcount",
                                      toolbar:
                                        "undo redo | bold italic | bullist numlist | help",
                                      content_style:
                                        "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                    }}
                                  />
                                ) : (
                                  <div
                                    className="step-note-content mt-2 p-2"
                                    style={{
                                      borderTop: "1px dashed #ddd",
                                      paddingTop: "10px",
                                      minHeight: "50px",
                                    }}
                                  >
                                    {step.note ? (
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: step.note,
                                        }}
                                      />
                                    ) : (
                                      <div className="text-muted font-italic">
                                        {meeting?.prise_de_notes === "Automatic"
                                          ? t("no summary available")
                                          : t("no note available")}
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            ))}
                        </div>
                      ) : (
                        <div className="no-steps-message text-center p-4 text-muted">
                          {t("No steps available")}
                        </div>
                      )}
                    </div>
                  </div>
                </Tab.Pane> */}

              {meeting?.prise_de_notes === "Automatic" &&  <Tab.Pane eventKey="meetingNotes">
                  <div className="row d-flex justify-content-center">
                    <div className="col-md-12 mb-3">
                      <>
                        <div
                          style={{
                            marginTop: "5rem",
                            marginBottom: "3rem",
                          }}
                        >
                          <h4
                            className={`participant-heading-meeting d-flex align-items-center justify-content-between`}
                          >
                            {viewNote === "note"
                              ? `${t("Notes")}`
                              : viewNote === "prompt"
                              ? `${t("Prompt")}: ${
                                  meeting?.solution
                                    ? meeting?.solution?.title
                                    : t(
                                        `types.${meeting?.prompts[0]?.meeting_type}`
                                      )
                                }`
                              : `${t("Transcript")}`}

                            <span
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              {/* Edit icon for notes */}
                              {viewNote === "note" && (
                               <Tooltip 
  arrow
  PopperProps={{
    sx: {
      "& .MuiTooltip-tooltip": {
        bgcolor: "#424242",
        fontSize: "0.8rem",
        padding: "6px 12px"
      },
      "& .MuiTooltip-arrow": {
        color: "#424242"
      }
    }
  }}
>
  <button
    className="toggle-button-option"
    onClick={() => setIsEditing(!isEditing)}
    style={{
      background: isEditing ? "#e8f0fe" : "transparent",
      border: "none",
      cursor: "pointer",
      padding: "8px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
      color: isEditing ? "#1967d2" : "#5f6368",
      boxShadow: isEditing ? "0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15)" : "none",
      ":hover": {
        background: isEditing ? "#d2e3fc" : "#f1f3f4",
        color: isEditing ? "#185abc" : "#202124",
        transform: "scale(1.1)",
        boxShadow: "0 1px 3px 0 rgba(60,64,67,0.302), 0 4px 8px 3px rgba(60,64,67,0.149)"
      },
      ":active": {
        transform: "scale(0.95)"
      }
    }}
  >
    <MdEdit size={18} style={{ transition: "transform 0.2s ease" }} />
  </button>
</Tooltip>
                              )}
                              {/* Conditionally show refresh if data is missing */}
                              {(viewNote === "note" &&
                                !meeting?.meeting_notes_summary) ||
                              (viewNote === "transcript" &&
                                !meeting?.meeting_notes_transcript) ? (
                                <Tooltip title={t("refresh_tooltip")}>
                                  <div className="toggle-button">
                                    <button
                                      className="toggle-button-option"
                                      // onClick={handleRefresh} // Define this function in your component
                                    >
                                      <MdRefresh size={18} />
                                    </button>
                                  </div>
                                </Tooltip>
                              ) : null}
                              <div className="toggle-button">
                                {sessionUser?.role?.name === "MasterAdmin" && (
                                  <button
                                    className={`toggle-button-option ${
                                      viewNote === "prompt" ? "active" : ""
                                    }`}
                                    onClick={() => handleViewToggle("prompt")}
                                  >
                                    <div className="icon-list" />
                                    <MdInfo size={20} />
                                  </button>
                                )}

                                <button
                                  className={`toggle-button-option ${
                                    viewNote === "note" ? "active" : ""
                                  }`}
                                  onClick={() => handleViewToggle("note")}
                                >
                                  <div className="icon-list" />
                                  <MdOutlineSummarize size={20} />
                                </button>
                                <button
                                  className={`toggle-button-option ${
                                    viewNote === "transcript" ? "active" : ""
                                  }`}
                                  onClick={() => handleViewToggle("transcript")}
                                >
                                  <div className="icon-graph" />
                                  <CgTranscript size={18} />
                                </button>
                              </div>
                            </span>
                          </h4>
                          {loading ? (
                            <div style={{ width: "100%", margin: "20px 0" }}>
                              <ProgressBar animated now={45} />
                              <h5 className="text-center">
                                {" "}
                                {t("note_translation.Processing Audio")}
                              </h5>
                            </div>
                          ) : (
                            <>
                              {viewNote === "note" ? (
                                summaryLoading || transcriptLoading ? (
                                  <>
                                    <div className="progress-container">
                                      <div
                                        className="progress"
                                        style={{ width: `${50}%` }}
                                      />
                                    </div>
                                    <h5 className="text-center">
                                      {t("note_translation.Processing Notes")}
                                    </h5>
                                  </>
                                ) : isEditing ? (
                                  <>

                                    <div
                                      style={{
                                        border: "1px solid #ddd",
                                        borderRadius: "4px",
                                        overflow: "hidden",
                                        minHeight: "350px",
                                      }}
                                    >
                                     <MDXEditor
  markdown={meetingSummary}
  onChange={(newValue) => {
    setMeetingSummary(newValue);
    debouncedAutoSave(newValue);
  }}
  plugins={[
    headingsPlugin(),
    listsPlugin(),
    markdownShortcutPlugin(),
  ]}
  contentEditableClassName="french-content-editor"
/>
                                    </div>
                                  </>
                                ) : (
                                  <div className="markdown-content">
                                    <ReactMarkdown
                                      remarkPlugins={[remarkGfm]}
                                      components={{
                                        h1: ({ node, ...props }) => (
                                          <h1 {...props} />
                                        ),
                                        h2: ({ node, ...props }) => (
                                          <h2 {...props} />
                                        ),
                                        h3: ({ node, ...props }) => (
                                          <h3 {...props} />
                                        ),
                                        p: ({ node, ...props }) => (
                                          <p {...props} />
                                        ),
                                        ul: ({ node, ...props }) => (
                                          <ul {...props} />
                                        ),
                                        ol: ({ node, ...props }) => (
                                          <ol {...props} />
                                        ),
                                        strong: ({ node, ...props }) => (
                                          <strong {...props} />
                                        ),
                                        code: ({ node, inline, ...props }) =>
                                          inline ? (
                                            <code {...props} />
                                          ) : (
                                            <code {...props} />
                                          ),
                                      }}
                                    >
                                      {markdownContent}
                                    </ReactMarkdown>
                                  </div>
                                )
                              ) : viewNote === "prompt" ? (
                                <div
                                  id="info-editable-content"
                                  contentEditable
                                  suppressContentEditableWarning={true} // Prevents React warning
                                  dangerouslySetInnerHTML={{
                                    __html: infoContent,
                                  }}
                                  onBlur={(e) =>
                                    setInfoContent(e.target.innerHTML)
                                  } // Save changes when focus is lost
                                  style={{
                                    maxWidth: "100%",
                                    whiteSpace: "normal",
                                    background: "#f8f9fa",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                    marginTop: "10px",
                                    minHeight: "50px",
                                  }}
                                />
                              ) : transcriptLoading ? (
                                <>
                                  <div className="progress-container">
                                    <div
                                      className="progress"
                                      style={{ width: `${50}%` }}
                                    />
                                  </div>
                                  <h5 className="text-center">
                                    {t(
                                      "note_translation.Fetching Transcription"
                                    )}
                                  </h5>
                                </>
                              ) : (
                                <>
                                  <label
                                    style={{
                                      display: "flex",
                                      justifyContent: "end",
                                      margin: "16px 9px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={isTimeStampChecked}
                                      onChange={handleCheckboxChange}
                                    />
                                    &nbsp;
                                    {t("note_translation.Show Timestamps")}
                                  </label>

                                  {isTimeStampChecked ? (
                                    <div
                                      style={{
                                        fontSize: "16px",
                                        lineHeight: "1.6",
                                        position: "relative",
                                      }}
                                    >
                                      {memoizedSentences?.map(
                                        (sentence, sentenceIndex) => (
                                          <p
                                            key={sentenceIndex}
                                            style={{ marginBottom: "8px" }}
                                          >
                                            <strong>
                                              [{sentence.start_time}s -{" "}
                                              {sentence.end_time}s]
                                            </strong>{" "}
                                            {sentence.words?.map(
                                              (wordObj, wordIndex) => {
                                                const wordId = `${sentenceIndex}-${wordIndex}`; // Unique ID for each word
                                                const isHovered =
                                                  hoveredWord?.wordId ===
                                                  wordId;

                                                return (
                                                  <span
                                                    key={wordIndex}
                                                    onMouseEnter={() =>
                                                      setHoveredWord({
                                                        word: wordObj.word,
                                                        wordId,
                                                      })
                                                    }
                                                    onMouseLeave={() =>
                                                      setHoveredWord(null)
                                                    }
                                                    style={{
                                                      position: "relative",
                                                      cursor: "text",
                                                      marginRight: "4px",
                                                      display: "inline-block",
                                                      backgroundColor: isHovered
                                                        ? "lightblue"
                                                        : "transparent", // Highlight hovered word
                                                      transition:
                                                        "background-color 0.2s ease", // Smooth transition
                                                    }}
                                                  >
                                                    {wordObj.word}{" "}
                                                    {isHovered &&
                                                    hoveredWord?.word ===
                                                      wordObj.word ? (
                                                      <span
                                                        style={{
                                                          position: "absolute",
                                                          bottom: "100%",
                                                          left: "50%",
                                                          transform:
                                                            "translateX(-50%)",
                                                          background: "black",
                                                          color: "white",
                                                          padding: "4px 6px",
                                                          borderRadius: "4px",
                                                          fontSize: "12px",
                                                          whiteSpace: "nowrap",
                                                          zIndex: 10,
                                                        }}
                                                      >
                                                        {wordObj.start_time}s
                                                      </span>
                                                    ) : null}
                                                  </span>
                                                );
                                              }
                                            )}
                                          </p>
                                        )
                                      )}
                                    </div>
                                  ) : (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: meetingTranscript,
                                      }}
                                    />
                                  )}
                                </>
                              )}

                              {viewNote === "note" ? (
                                <div className="mt-2">
                                  <button
                                    className={`btn moment-btn`}
                                    onClick={() => handleSave1(meeting)}
                                    style={{
                                      background: "#0026b1",
                                      color: "white",
                                      fontFamily: "Inter",
                                      fontSize: "14px",
                                      fontWeight: 500,
                                      lineHeight: "20px",
                                      textAlign: "left",
                                      padding: "10px 16px",
                                    }}
                                  >
                                    {autoNoteSaving ? (
                                      <Spinner
                                        as="div"
                                        variant="light"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        animation="border"
                                        style={{
                                          margin: "2px 12px",
                                        }}
                                      />
                                    ) : (
                                      t("meeting.formState.Update")
                                    )}
                                  </button>
                                </div>
                              ) : viewNote === "prompt" ? (
                                <div className="mt-2">
                                  <button
                                    className={`btn moment-btn`}
                                    onClick={() => handleUpdatePrompt(meeting)}
                                    style={{
                                      background: "#0026b1",
                                      color: "white",
                                      fontFamily: "Inter",
                                      fontSize: "14px",
                                      fontWeight: 500,
                                      lineHeight: "20px",
                                      textAlign: "left",
                                      padding: "10px 16px",
                                    }}
                                  >
                                    {isSaving ? (
                                      <Spinner
                                        as="div"
                                        variant="light"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        animation="border"
                                        style={{
                                          margin: "2px 12px",
                                        }}
                                      />
                                    ) : (
                                      t("meeting.formState.Update&apply")
                                    )}
                                  </button>
                                </div>
                              ) : null}
                            </>
                          )}
                        </div>
                      </>
                    </div>
                  </div>
                </Tab.Pane>}

                <Tab.Pane eventKey="files">
                  <div className="row d-flex justify-content-center">
                    <div className="col-md-12 mb-3">
                      {/* ------------------------------------------------ Files */}
                      <div>
                        <div style={{ marginTop: "5rem" }}>
                          <h4 className={`participant-heading-meeting`}>
                            {`${t("meeting.newMeeting.labels.file")} `}
                          </h4>
                          <CompletedMomentStepFile
                            data={meeting?.meeting_files}
                            openModal={openModal}
                            refreshMeetings={getRefreshedMeeting}
                          />
                        </div>
                        {isModalOpen && (
                          <ViewFilePreview
                            isModalOpen={isModalOpen}
                            setIsModalOpen={setIsModalOpen}
                            modalContent={modalContent}
                            closeModal={closeModal}
                            isFileUploaded={isFileUploaded}
                            setIsFileUploaded={setIsFileUploaded}
                            refreshMeeting={getRefreshMeeting}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </Tab.Pane>

                <Tab.Pane eventKey="feedbacks">
                  <div className="row d-flex justify-content-center">
                    <div className="col-md-12 ">
                      {meeting?.meeting_feedbacks?.length > 0 && (
                        <div style={{ marginTop: "5rem" }}>
                          <h4 className={`participant-heading-meeting`}>
                            {`${t(
                              "meeting.newMeeting.labels.momentFeedback"
                            )} `}
                          </h4>
                          <FeedbackCard meeting={meeting} />
                        </div>
                      )}
                    </div>
                  </div>
                </Tab.Pane>

                <Tab.Pane eventKey="discussion">
                  <div className="row d-flex justify-content-center">
                    <div className="col-md-12 mb-3">
                      {/* ------------------------------------------------ Files */}
                      <div
                      // style={{
                      //   marginTop: "3rem",
                      //   marginBottom: "3rem",
                      // }}
                      >
                        {/* <h4 className="participant-heading-meeting">
                          {`${t("meeting.newMeeting.labels.discussion")} `}
                        </h4> */}

                        <MeetingDiscussion
                          meetingId={id}
                          messages={meetingMessages}
                          selectedMoment={meeting}
                          onMessagesUpdate={(newMeetings) =>
                            setMeetingMessages(newMeetings)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>

          <div
            className="cards-section child-2"
            style={{ marginBottom: "4rem" }}
          >
            {/* ------------------------------------------------ Meeting Notes */}
            {meeting?.note_taker === true &&
              meeting?.location === "Google Meet" && (
                <div style={{ marginTop: "5rem", marginBottom: "3rem" }}>
                  <h4
                    className={`${
                      fromMeeting
                        ? "participant-heading-meeting"
                        : "participant-heading"
                    } d-flex align-items-center justify-content-between`}
                  >
                    {`${t("Notes")} `}

                    <span style={{ cursor: "pointer" }}>
                      <div
                        className="toggle-button"
                        style={{ padding: "12px" }}
                      >
                        {editMode ? (
                          <CiEdit
                            onClick={handleEditToggle}
                            size={18}
                            color="blue"
                          />
                        ) : (
                          <CiEdit onClick={handleEditToggle} size={18} />
                        )}
                      </div>
                    </span>
                  </h4>

                  {showReportProgressBar && !isCalling ? (
                    <div
                      style={{
                        padding: "10px 32px",
                      }}
                    >
                      <ProgressBar now={reportProgress} />
                      <p>Loading report data...</p>
                    </div>
                  ) : (
                    <div
                      className="meeting-notes"
                      style={{
                        padding: "10px 32px",
                      }}
                    >
                      {editMode ? (
                        <div
                          id="editable-content"
                          contentEditable
                          dangerouslySetInnerHTML={{ __html: reportData }}
                          style={{
                            border: "1px solid #ccc",
                            padding: "10px",
                            minHeight: "150px",
                          }}
                        />
                      ) : (
                        <div dangerouslySetInnerHTML={{ __html: reportData }} />
                      )}

                      {editMode && (
                        <div className="mt-2">
                          <button
                            className={`btn moment-btn`}
                            onClick={handleSave}
                            style={{
                              background: "#0026b1",
                              color: "white",
                              fontFamily: "Inter",
                              fontSize: "14px",
                              fontWeight: 500,
                              lineHeight: "20px",
                              textAlign: "left",
                              padding: "10px 16px",
                            }}
                          >
                            {isSaving ? (
                              <Spinner
                                as="div"
                                variant="light"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                animation="border"
                                style={{
                                  margin: "2px 12px",
                                }}
                              />
                            ) : (
                              t("meeting.formState.Update")
                            )}
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

            {meeting?.plan_d_actions?.length > 0 && (
              <div
                className="row"
                style={{ marginTop: "5rem", marginBottom: "3rem" }}
              >
                <h4
                  className={
                    fromMeeting
                      ? "participant-heading-meeting d-flex justify-content-between align-items-center"
                      : "participant-heading d-flex justify-content-between align-items-center"
                  }
                >
                  {`${t("planDActions")} `}
                  <Button
                    className="play-btn"
                    onClick={() => {
                      if (
                        meeting?.plan_d_actions[0]?.strategy_meeting?.status ===
                        "closed"
                      ) {
                        navigate(
                          `/present/invite/${meeting?.plan_d_actions[0]?.strategy_meeting?.id}`,
                          { state: { meeting, from: "meeting" } }
                        );
                      } else {
                        navigate(
                          `/invite/${meeting?.plan_d_actions[0]?.strategy_meeting?.id}`,
                          {
                            state: { meeting, from: "meeting" },
                          }
                        );
                      }
                    }}
                  >
                    {t("dropdown.View")}
                  </Button>
                </h4>
                <div className="col-md-12">
                  <Table bordered className="action-table">
                    <thead>
                      <tr className="table-row">
                        {/* <th className="table-row-head"></th> */}
                        <th
                          className="table-row-head"
                          style={{
                            paddingLeft: "38px",
                          }}
                        >
                          {t("tasks")}
                        </th>
                        <th className="table-row-head text-center">
                          {t("duration")}
                        </th>
                        <th className="table-row-head text-center">
                          {t("participant")}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredActions?.map((user, index) => (
                        <tr className="table-data" key={user?.id}>
                          <td
                            style={{ width: "70%", paddingLeft: "28px" }}
                            className="table-data-row"
                          >
                            {user?.action}
                          </td>
                          <td className="text-center table-data-row ">
                            <span className="duree">
                              {String(user?.action_days).split(".")[0]}
                            </span>
                          </td>
                          <td className="text-center table-data-row">
                            <Tooltip
                              title={user?.participant_full_name}
                              placement="top"
                            >
                              <Avatar
                                src={
                                  user?.participant_image?.includes("users")
                                    ? Assets_URL + "/" + user?.participant_image
                                    : user?.participant_image
                                }
                              />
                            </Tooltip>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            )}

            {meeting?.step_decisions &&
              meeting?.step_decisions.some((decision) => decision !== null) && (
                <div
                  className="decision-section"
                  style={{ marginTop: "5rem", marginBottom: "3rem" }}
                >
                  <div style={{ marginTop: "2rem" }}>
                    <h4 className="participant-heading-meeting">
                      {`${t("meeting.newMeeting.labels.decisions")} `}
                    </h4>

                    <ReportDecisionCard
                      data={meeting?.steps}
                      meeting={meeting}
                      disabled={isDisabled}
                    />
                  </div>
                </div>
              )}
          </div>
        </div>
      )}
      {open && (
        <div className="tabs-container">
          <NewMeetingModal open={open} closeModal={handleCloseModal} />
        </div>
      )}

      {showConfirmationModal && (
        <ConfirmationModal
          message={t("meetingDeletedToast")}
          onConfirm={(e) => confirmDelete(e)}
          onCancel={(e) => {
            e.stopPropagation();
            setShowConfirmationModal(false);
          }}
        />
      )}
      {showFileModal && (
        <div className="file-modal-overlay">
          <div
            className="file-modal-content w-100 h-100"
            style={{ background: "rgb(242, 244, 251)" }}
          >
            <button
              className="file-modal-close"
              onClick={() => setShowFileModal(false)}
            >
              ×
            </button>
            <FileUploadModal
              meetingId={meeting?.id}
              setShowFileModal={setShowFileModal}
              isFileUploaded={isFileUploaded}
              setIsFileUploaded={setIsFileUploaded}
              refreshMeeting={getRefreshMeeting}
            />
          </div>
        </div>
      )}

      {editingField && (
        <Modal
          show={true}
          onHide={() => setEditingField(null)}
          centered
          backdrop="static"
          size={editingField === "description" ? "xl" : "md"} // xl for description, lg for title
          dialogClassName={
            editingField === "description" ? "description-edit-modal" : ""
          }
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {t("edit")} {t(`fieldNames.${editingField}`)}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {editingField === "description" ? (
              <Editor
                apiKey={APIKEY}
                onInit={(evt, editor) => (editorRef.current = editor)}
                value={editValue}
                onEditorChange={handleEditorChange}
                init={{
                  height: 480,
                  menubar: true,
                  plugins: [
                    "advlist autolink lists link image charmap print preview anchor",
                    "searchreplace visualblocks code fullscreen",
                    "insertdatetime media table paste code help wordcount",
                    "image",
                    "imagetools",
                  ],
                  toolbar:
                    "undo redo | formatselect | bold italic underline | \
                               alignleft aligncenter alignright alignjustify | \
                               bullist numlist outdent indent | link image | \
                               code | fullscreen | help",

                  /* Cloudinary Image Handling */
                  automatic_uploads: true,
                  images_upload_handler: async (blobInfo, progress) => {
                    progress(0);
                    try {
                      const url = await uploadToCloudinary(blobInfo);
                      progress(100);
                      return url;
                    } catch (error) {
                      progress(0);
                      throw error;
                    }
                  },

                  /* Enable all image input methods */
                  paste_data_images: true,
                  file_picker_types: "image",

                  /* Image enhancements */
                  image_caption: true,
                  image_advtab: true,
                  image_title: true,

                  // 🟢 Enable resizing images with the mouse
                  resize_img_proportional: true, // Optional: constrain proportions
                  object_resizing: true, // or 'img' to target only images
                  image_dimensions: true, // shows width/height fields and supports inline sizing

                  image_class_list: [
                    { title: "Responsive", value: "img-responsive" },
                    { title: "Rounded", value: "img-rounded" },
                  ],

                  /* Responsive images by default */
                  content_style: `
                              
                               img.img-rounded { border-radius: 8px; }
                             `,
                }}
              />
            ) : (
              <input
                type="text"
                className="form-control"
                value={editValue}
                onChange={(e) => setEditValue(e.target.value)}
              />
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={() => setEditingField(null)}>
              {t("Cancel")}
            </Button>
            <button
              className="btn"
              style={{
                background: "#0026b1",
                color: "white",
                fontFamily: "Inter",
                fontSize: "14px",
                fontWeight: 500,
                lineHeight: "20px",
                textAlign: "left",
                padding: "10px 16px",
              }}
              onClick={handleSaveEdit}
            >
              {t("Validate")}
            </button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default CompletedInvite;
